export const cards = [
    '00-TheFool',
    '01-TheMagician',
    '02-TheHighPriestess',
    '03-TheEmpress',
    '04-TheEmperor',
    '05-TheHierophant',
    '06-TheLovers',
    '07-TheChariot',
    '08-Strength',
    '09-TheHermit',
    '10-WheelOfFortune',
    '11-Justice',
    '12-TheHangedMan',
    '13-Death',
    '14-Temperance',
    '15-TheDevil',
    '16-TheTower',
    '17-TheStar',
    '18-TheMoon',
    '19-TheSun',
    '20-Judgement',
    '21-TheWorld',
];
export const cardsName = {
    '00-TheFool':          '愚者',
    '01-TheMagician':      '魔術師',
    '02-TheHighPriestess': '女教皇',
    '03-TheEmpress':       '女帝',
    '04-TheEmperor':       '皇帝',
    '05-TheHierophant':    '法王',
    '06-TheLovers':        '恋人',
    '07-TheChariot':       '戦車',
    '08-Strength':         '力',
    '09-TheHermit':        '隠者',
    '10-WheelOfFortune':   '運命の輪',
    '11-Justice':          '正義',
    '12-TheHangedMan':     '吊るされた男',
    '13-Death':            '死神',
    '14-Temperance':       '節制',
    '15-TheDevil':         '悪魔',
    '16-TheTower':         '塔',
    '17-TheStar':          '星',
    '18-TheMoon':          '月',
    '19-TheSun':           '太陽',
    '20-Judgement':        '審判',
    '21-TheWorld':         '世界',
};
export const cardDirection = {upright: '正位置', reverse: '逆位置'};
export const cardsText = {upright: {}, reverse: {}};

//------------------------------------------------------------
// # 00 愚者 正位置 極端な自由
cardsText.upright['00-TheFool'] = [

'「愚者」の正位置は「極端な自由」を象徴し、新たな可能性や未知の方向性が示唆されます。',

// ### あなたの気持ち  
'あなたは今、自由や冒険心に満ちており、相手との関係に対して縛られたくないという気持ちが強いです。心の中では、新しいことに挑戦したい、もっと自分自身を開放したいという衝動が渦巻いているでしょう。従来のルールや期待にとらわれず、自分の心の声に従いたいと感じているため、相手との関係においても新たな展開を望んでいるかもしれません。束縛やルーチンに息苦しさを感じつつも、未知の可能性を感じており、未来に対して楽観的な姿勢を持っています。',

// ### 相手の気持ち  
'相手は、あなたとは異なる視点を持ちつつも、自由を求める側面を持っているかもしれません。相手は、自分自身の人生や個人的な成長に重点を置いており、あなたに対しても縛られたくないという潜在的な意識を持っている可能性があります。相手は一方で、新たな経験や関係性の変化を歓迎する気持ちを持っているかもしれませんが、その自由さが時折、関係の方向性を不確かにさせているように感じることもあるでしょう。自分の選択肢を広げたいという願望があり、楽観的な未来を信じています。',

// ### 2人の現状  
'現在、2人の関係はまさに変化の入口に立っていると言えます。お互いがそれぞれに自由や冒険心を求めており、従来の枠組みや制約を超えた新しい段階に進む可能性が高まっています。しかし、その自由さは一方で関係の安定性を揺るがす要因にもなり得ます。2人は、共にいることに対する責任感よりも、お互いの成長や変化を優先している状況にあるかもしれません。この自由さがポジティブに働くか、逆に関係に亀裂を生むかは、今後の選択にかかっています。',

// ### 2人の近い未来  
'2人の近い未来には、新たな冒険や変化が待っているでしょう。自由を追い求める心が強い2人は、これまで以上に関係を自由に、軽やかに捉えるかもしれません。この変化が、関係を一層発展させるきっかけとなるか、逆に別々の道を選ぶ結果となるかは、今後の互いの意思疎通次第です。ただし、自由を尊重し合うことができれば、相手との間に新たな信頼と絆が生まれる可能性もあります。未来は未知ですが、どちらの選択も2人にとって成長のチャンスとなるでしょう。',
];

//------------------------------------------------------------
// # 01 魔術師 正位置 成功への期待
cardsText.upright['01-TheMagician'] = [

'「魔術師」の正位置は、「成功への期待」や「自己実現」を象徴し、前向きな展望や積極的な変化が期待されます。',

// ### あなたの気持ち  
'あなたは、今まさに自分の意思や行動によって、相手との関係を成功へと導こうという強い意志を持っています。自信に満ちており、相手とのコミュニケーションや関係性の中で、自分の望む結果を手に入れるための手段を積極的に探している段階です。あなたは、相手に対して強い期待を抱いており、関係をより深めたり進展させるために、具体的なアクションを取る準備が整っています。今後、柔軟な発想と前向きな姿勢で、2人の関係にポジティブな影響を与えることでしょう。',

// ### 相手の気持ち  
'相手もまた、あなたとの関係に対して前向きなエネルギーを感じているようです。相手は自分自身の可能性を見つめつつ、あなたとの関係においても積極的に進展を図りたいと考えているでしょう。相手は自己表現や新たな挑戦を好む傾向があり、関係をより創造的で刺激的なものにしようという意識を持っています。お互いに信頼を築きながら、一歩ずつ未来に向けた行動を取ることを大切にしているため、関係は明るい兆しを見せています。',

// ### 2人の現状  
'現時点で、2人の関係は非常にポジティブであり、お互いに対する信頼感や協力的な姿勢が強く感じられます。お互いが目指す方向性が一致しており、それぞれが自己実現をしながら関係を築くという理想的な状態に近づいています。今、2人はお互いにとって重要な存在であり、成長を支え合いながら、成功を目指して共に歩んでいます。特に、何か大きな目標やプロジェクトに取り組む場合には、非常に良い結果を得ることができるでしょう。',

// ### 2人の近い未来  
'近い未来において、2人の関係はさらに深まり、互いの意志や行動が具体的な成果を生み出す可能性が高いです。「魔術師」が示すように、これからの関係には大きな成功の期待がかかっています。特に、2人の共同作業や協力が必要な状況では、素晴らしい結果がもたらされるでしょう。未来は、強い信頼と前向きな行動によって築かれていきます。これまでの努力が報われ、関係の成功に向けた一歩を踏み出す時が訪れています。',
];

//------------------------------------------------------------
// # 02 女教皇 正位置 精神の強さ
cardsText.upright['02-TheHighPriestess'] = [

'「女教皇」の正位置は「精神の強さ」や「内なる知恵」を象徴し、深い理解や直感、感情の調和が重要なテーマとなります。',

// ### あなたの気持ち  
'あなたは今、相手との関係において、感情に流されるのではなく冷静さを保ち、内面的な強さを大切にしています。表面上の状況に左右されず、静かに相手の行動や言葉を観察し、深い洞察を得ている状態です。自分自身の内なる声に耳を傾け、感情的に急ぐことなく、長期的な視点から相手との関係を見つめようとしています。時折、相手に対して距離を感じることがあるかもしれませんが、それはあなた自身が自分の心を守り、冷静な判断を保とうとしているからです。',

// ### 相手の気持ち  
'相手はあなたに対して、感情的な絆を感じつつも、理性的で冷静なアプローチをしているようです。相手は、自分の感情を過度に表に出さず、慎重に言葉を選びながら関係を築こうとしています。相手の内心では、あなたに対して深い尊敬や信頼を持っているものの、それをすぐに表現するのではなく、慎重に関係を進めていく姿勢が見られます。相手にとって、あなたとの関係は特別であり、簡単に感情に流されないような慎重さが示されています。',

// ### 2人の現状  
'現在の2人の関係は、表面的には静かで穏やかなものに見えるかもしれませんが、内面ではお互いに対する深い理解や信頼が育まれています。感情的な起伏が少なく、理性的な対話やお互いを尊重する態度が主導しているため、安定した基盤が形成されつつあります。言葉や行動で強く表現されることは少ないものの、心の底で繋がりを感じ合っている状態です。この静かな関係は、時間と共にさらに深まり、お互いの真の姿がより明確に見えてくるでしょう。',

// ### 2人の近い未来  
'2人の未来は、静かでありながらも内面的な成長と深い絆がさらに強固になることが予測されます。感情的なドラマが少ないため、一見、関係に変化がないように見えるかもしれませんが、実際には精神的なつながりが深まっていきます。内なる知恵と直感が働き、2人は互いに支え合い、精神的な成長を促す存在として関係を発展させるでしょう。時間と共に、お互いの本質的な価値を見出し、より深い理解と信頼のもとで未来を築いていくことができます。',
];

//------------------------------------------------------------
// # 03 女帝 正位置 豊かさや愛情
cardsText.upright['03-TheEmpress'] = [

'「女帝」の正位置は「豊かさ」や「愛情」「成長」を象徴し、愛情や物質的な安定、感情的な豊かさが示されています。',

// ### あなたの気持ち  
'あなたは今、相手に対して深い愛情と献身を感じており、関係を通じて豊かな感情や満足感を得ている状態です。相手に対して心からの愛情を注ぎ、関係が自然と成長していくことを信じています。あなたは、相手との時間や共有する経験が非常に大切であり、物質的な安定や安心感も求めているでしょう。今のあなたは、相手に対して包み込むような優しさや共感を持ち、関係を大切にしながら育んでいこうという意志を強く持っています。',

// ### 相手の気持ち  
'相手はあなたに対して非常に感謝と愛情を感じており、その気持ちは安定感と満足感に満ちています。相手は、あなたが与える豊かさや愛情に深く感銘を受け、自分自身もその愛情に応えたいという強い気持ちを持っています。相手は、今後の関係においても安定した幸福や豊かな感情の共有を望んでおり、関係がさらに深まり、実りあるものになることを期待しています。相手は、あなたとの未来に対してポジティブなビジョンを描き、安定した家庭やパートナーシップを築くことに前向きです。',

// ### 2人の現状  
'現在、2人の関係は非常に充実しており、愛情と安定感が際立っています。2人はお互いに感情的な支え合いや物質的な安定を提供し合っており、関係が成長し、豊かな成果を生み出している段階です。互いの存在が安心感を与え、これからも一緒に成長していくという強い信頼感が築かれています。お互いを支え合うことで、感情的にも物質的にも安定した未来が期待でき、今の関係は充実感に満ちています。幸福や愛情があふれる関係が進行中です。',

// ### 2人の近い未来  
'近い未来において、2人の関係はさらなる豊かさと成長を迎えるでしょう。女帝のカードが示すように、感情的な充実や物質的な安定が続く中で、2人はさらに深い愛情を築くことができます。特に、関係において新たなステージに進む可能性があり、家庭や子供、または共同の目標を持つことが期待されます。お互いの愛情やサポートが実り、関係はより実質的かつ安定したものとなり、幸福な未来へと歩み続けるでしょう。',
];

//------------------------------------------------------------
// # 04 皇帝 正位置 自立や統率力
cardsText.upright['04-TheEmperor'] = [

'「皇帝」の正位置は「自立」や「統率力」「安定」を象徴し、責任感やリーダーシップ、安定した基盤が強調されます。',

// ### あなたの気持ち  
'あなたは今、相手との関係において自立心を強く持っており、自分自身の役割や責任をしっかりと果たしたいという意識が強いです。相手に依存することなく、独立した存在として関係に貢献しながらも、しっかりとしたリーダーシップを発揮していきたいという思いが湧いています。関係を安定させ、長期的な視点で築いていくために、感情的に流されるのではなく、冷静で計画的なアプローチを重視しているでしょう。あなたは、相手とのパートナーシップを強固にし、信頼と安定を基盤にした関係を目指しています。',

// ### 相手の気持ち  
'相手もまた、関係に対して強い責任感を感じており、あなたとの関係を堅実に維持しようとしています。相手は、関係を成り立たせるためのリーダーシップを取る意志があり、時に実務的な視点で未来を計画し、現実的な行動を取ることを大切にしています。相手は感情的な面よりも、安定した未来を見据えた戦略的な思考を持っており、2人の関係を強固にするための行動を積極的に進めている状態です。特に、関係の安定を第一に考え、成熟した関係を築きたいという願望を持っています。',

// ### 2人の現状  
'現在の2人の関係は、非常に安定しており、明確なリーダーシップや責任感が感じられます。お互いが自立した存在として成り立ちながらも、共通の目標に向かって協力し合い、計画的に未来を構築している段階です。感情的な波風が少なく、冷静で実際的な対話が重視されているため、関係は成熟し、安定しています。お互いに自分の役割をしっかりと理解し、それを全うする姿勢が、信頼をより一層強固なものにしています。長期的な視野に立った関係が進展しています。',

// ### 2人の近い未来  
'2人の未来は、さらに安定し、強固な基盤の上に築かれていくでしょう。皇帝のカードが示すように、リーダーシップや計画性が発揮され、関係は次の段階へと進む可能性があります。お互いの役割分担や責任感が明確になることで、未来の目標がより現実的なものとして見えてくるでしょう。共に歩む道のりが計画的に進められることで、感情的な不安定さや不確実性は少なく、堅実なパートナーシップが続いていきます。お互いの意志を尊重し合いながら、より成熟した関係が発展していくでしょう。',
];

//------------------------------------------------------------
// # 05 法王 正位置 慈悲や協調性
cardsText.upright['05-TheHierophant'] = [

'「法王」の正位置は「慈悲」「協調性」「伝統」を象徴し、信頼や精神的なつながり、または共通の価値観が重要視されることを示しています。',

// ### あなたの気持ち  
'あなたは、相手との関係において共感や協調を大切にし、相手を深く理解し、受け入れようとする姿勢を持っています。相手との信頼関係を重視し、互いに助け合いながら安定した関係を築こうという意識が強いです。あなたは、相手に対して寛容であり、2人の関係が持つ精神的な価値や共通の目標に目を向けています。また、伝統的な価値観や安定した基盤の中で、相手と共に長期的な未来を築こうと考えているでしょう。相手との対話や共通の理解を通じて、関係をより深める意欲を持っています。',

// ### 相手の気持ち  
'相手は、あなたとの関係において精神的な支えを感じており、あなたに対して尊敬と信頼を抱いています。相手は、関係の中でお互いの役割や価値観を尊重し、あなたと共に協力し合いながら前進していこうとする姿勢を持っています。相手は、安定した関係を求め、時には伝統的な方法や共通の価値観に基づいて決断を下すことを大切にしています。関係において、信頼や協調が優先され、互いに支え合うことで長期的な絆を築きたいという願望を持っているでしょう。',

// ### 2人の現状  
'現在、2人の関係は信頼と協調に基づいており、互いにとっての精神的な支えとなっています。お互いが共通の価値観や目的を共有し、安定した基盤を築くために協力している状況です。感情的な対立や誤解が少なく、理性的かつ温かな対話が続いています。関係は成熟し、お互いに対する尊敬と理解が深まっています。また、2人はそれぞれの役割を理解し、共に歩むための意識を持っており、精神的な繋がりが強調されています。',

// ### 2人の近い未来  
'近い未来において、2人の関係はさらに深い信頼と協調を基盤に発展していくでしょう。法王のカードが示すように、互いに慈悲や寛容さを持ちながら、共通の価値観や目標に向かって進むことができます。特に、2人の関係がより深いレベルで安定し、長期的な視野での成長が期待されます。信頼関係を軸にしたコミュニケーションが強化され、互いを支え合うことで、絆はさらに強固なものとなります。共に未来を築くための具体的なプランが進行し、安定した関係が続いていくでしょう。',
];

//------------------------------------------------------------
// # 06 恋人 正位置 愛情や幸福
cardsText.upright['06-TheLovers'] = [

'「恋人」の正位置は「愛情」「幸福」「選択」を象徴し、愛情の深まりや強い絆、感情的な充足が強調されます。',

// ### あなたの気持ち  
'あなたは、相手に対して深い愛情を抱いており、関係の中で幸福感や充実感を強く感じています。相手との時間を大切にし、心の中で「これは運命的な出会いだ」と感じることもあるでしょう。あなたは、相手との関係が自分にとってかけがえのないものであり、この先も一緒に歩んでいく未来を自然に描いている状態です。感情的なつながりが強く、愛情が溢れており、相手とともにあることで安心感と喜びを感じています。また、今後の関係をどう進めていくかについても前向きに考えています。',

// ### 相手の気持ち  
'相手もまた、あなたに対して深い愛情を抱いており、関係において満足感と幸福を感じています。相手はあなたとの絆を非常に大切にし、互いに補い合う関係が成り立っていることに感謝しているでしょう。特に、相手はあなたとの未来に期待を抱き、2人で共に過ごす時間がさらに深まっていくことを望んでいます。愛情の絆が深まるにつれて、相手はあなたとの関係を強く確信し、心の中で「この人と一緒にいたい」という気持ちをさらに強めています。2人の関係は相手にとっても非常に大切なものです。',

// ### 2人の現状  
'現在の2人の関係は、愛情と幸福に満ちています。感情的な絆が深まり、お互いに対して強い信頼と愛情を感じている状態です。2人は、互いにとってかけがえのない存在であり、共に過ごす時間が一層特別なものとなっています。コミュニケーションもスムーズで、お互いの心の中で感じていることを素直に表現し合うことで、さらに深い理解と絆を築いています。関係は安定し、愛情が根底にあることで、2人はこの幸福な状態を続けていきたいと感じています。',

// ### 2人の近い未来  
'近い未来において、2人の関係はさらに愛情が深まり、幸福感が増していくでしょう。恋人のカードが示すように、2人の間には強い絆が生まれており、今後も互いに対して献身的な愛情を持ち続けることが期待されます。お互いの感情がますます豊かに育まれ、より深い信頼と理解のもとで未来を共に歩んでいくでしょう。また、関係を進展させるための選択や重要な決断が求められる場面が訪れる可能性もありますが、その選択は愛と理解に基づいたもので、2人の未来をより明るいものに導くでしょう。',
];

//------------------------------------------------------------
// # 07 戦車 正位置 勝利や前進
cardsText.upright['07-TheChariot'] = [

'「戦車」の正位置は「勝利」「前進」「決意」を象徴し、障害を乗り越えて前進する力強さが強調されます。',

// ### あなたの気持ち  
'あなたは、2人の関係を強く前進させたいという強い意志を持っています。どんな障害や問題が立ちはだかっても、それを乗り越えて関係をさらに発展させるために行動を起こす覚悟があるでしょう。あなたは自分の感情をしっかりとコントロールし、情熱的に相手との未来を築いていきたいと考えています。関係に対する強い責任感とリーダーシップを発揮し、前向きな姿勢で進んでいこうとする気持ちが、関係を動かす大きな原動力となっています。',

// ### 相手の気持ち  
'相手もまた、関係を進展させるための強い意志を持っており、2人で共に未来に向かって進むことを望んでいます。相手は、困難や挑戦に対して決して後退せず、むしろそれらを克服するための努力を惜しまないでしょう。あなたとの関係を大切にし、共に進んでいくために力を合わせる覚悟があります。また、相手は、関係の中でリーダーシップを発揮し、積極的に前向きな行動を取ることで、2人の絆をさらに強化したいと考えています。成功に向かう自信と決意がみなぎっている状態です。',

// ### 2人の現状  
'現在、2人の関係は非常に活気に満ちており、前向きなエネルギーが溢れています。お互いが共に未来を切り開いていくために、強い意志を持ち、力を合わせて前進しようとしている状況です。2人の間には、目標に向かって突き進む強い決意があり、互いにサポートし合いながら困難を乗り越えていく姿勢が見られます。関係はまさに動き出したばかりであり、今後も勢いを持って進んでいくことが期待されます。共通の目標や方向性に向かって、協力して進む姿が象徴されています。',

// ### 2人の近い未来  
'近い未来において、2人の関係はさらに強力に前進し、大きな成果を手にするでしょう。戦車のカードが示すように、目標に向かって突き進む強い意志と決断力が成功に導くカギとなります。障害や困難があっても、それらを乗り越えて関係を強化し、より深い絆を築いていくことができるでしょう。2人の未来は、協力し合いながら一緒に成し遂げた勝利や達成感に満ちたものとなるでしょう。お互いの意志を尊重し合い、さらに深い信頼関係が築かれ、関係は一層強固なものとなります。',
];

//------------------------------------------------------------
// # 08 力 正位置 勇気や強さ
cardsText.upright['08-Strength'] = [

'「力」の正位置は「勇気」「内面の強さ」「忍耐」を象徴し、感情的なバランスと自己制御、信頼が重要な要素として強調されます。',

// ### あなたの気持ち  
'あなたは、相手との関係において深い愛情と忍耐力を持っており、どんな困難があってもそれを乗り越える自信と強さを感じています。感情的に動揺することなく、冷静さを保ちつつ相手を理解し、支える覚悟ができています。あなたは、相手との関係を深めるために自分の内面の強さを発揮し、相手に対しても大きな愛と信頼を注いでいます。どんな状況でも自分の感情をコントロールし、相手と共に乗り越えていくための強い意志を持っており、相手に安心感を与える存在となっています。',

// ### 相手の気持ち  
'相手もまた、あなたとの関係において感情の安定と内面の強さを発揮し、関係を守るために積極的な姿勢を取っています。相手は、あなたに対して深い信頼を抱き、その信頼に応えるための強い意志を持っています。相手は、関係を健全に保つために自制心を持ちながらも、情熱を失うことなく前進しようとしています。また、相手は感情に流されず、冷静でありながらも愛情深い態度で、あなたとの絆を強化していくことを目指しています。関係に対して誠実であり、忍耐強く支え合う姿勢が見られます。',

// ### 2人の現状  
'現在の2人の関係は、内面の強さとお互いを支える力が根底にあり、非常に安定しています。お互いに対して深い信頼を持ち、感情的な衝突があったとしてもそれを冷静に乗り越えられるだけの強さが2人に備わっています。感情を抑えるのではなく、理性と感情のバランスを取りながら、互いを支え合い、理解し合う関係が成り立っています。2人はお互いを尊重し、時には困難を共に乗り越えることで、より強い絆を築いています。安定した関係を保つための調和が強調されます。',

// ### 2人の近い未来  
'近い未来において、2人の関係はさらなる強さと安定を見せるでしょう。力のカードが示すように、互いの信頼と忍耐が関係を支え続け、どんな困難も一緒に乗り越えていくことができます。今後も、お互いに支え合いながら共に成長し、感情的な絆を深めていくでしょう。特に、内面の強さが試されるような状況でも、2人は協力し合い、困難を克服することができるでしょう。愛と勇気が、関係をさらに強固なものに導いていく未来が期待されます。',
];

//------------------------------------------------------------
// # 09 隠者 正位置 充足や思慮深さ
cardsText.upright['09-TheHermit'] = [

'「隠者」の正位置は「内省」「充足」「思慮深さ」を象徴し、内面的な成長や深い思慮、静かな時間が強調されます。',

// ### あなたの気持ち  
'あなたは現在、相手との関係について深く内省する時期にあります。外面的なアクションよりも、静かに心の内側を見つめ、相手との絆や感情を見直しているでしょう。急いで進めるというよりは、少し距離を置いて冷静に考えることが重要であると感じているようです。愛情は変わらないものの、自分自身の気持ちを整理することで、より明確な未来を見据えたいと願っています。また、相手に対する理解を深めようとする姿勢もあり、表面上の関係以上に、内面的なつながりを重視している状態です。',

// ### 相手の気持ち  
'相手もまた、あなたとの関係において冷静で思慮深い態度を取っています。相手は今、自分自身や2人の関係について内省し、慎重に未来を考えようとしています。感情に流されることなく、長期的な視野で物事を考え、あなたとの関係がどう進展するかを深く見つめ直しているでしょう。積極的に動くというよりも、今は内面の充実や自己理解を優先しており、相手もまた、関係における本質を掘り下げて考えています。2人の関係は表面的ではなく、相手もあなたと同様に、内面的な成長を重視している状態です。',

// ### 2人の現状  
'現在、2人の関係は急激な進展や変化を求めるものではなく、むしろ静かな安定の中にあります。お互いが内省し、深く思慮することで、2人の関係は一時的に静寂を迎えているようです。感情の嵐ではなく、穏やかで静かな時間が2人の間に流れ、互いの心の深い部分を見つめ合う時期です。表面的なアクションは少ないかもしれませんが、内面的な成長や関係性の本質が培われており、この期間を通じて2人の理解が深まっていくでしょう。この静けさは、次なるステップへの準備段階でもあります。',

// ### 2人の近い未来  
'近い未来、2人の関係は内面的な成熟を伴い、深い理解と信頼に基づく新たな段階へと進むでしょう。「隠者」のカードが示すように、互いの内面を見つめ直すことで、これまで気づかなかった感情や思いに気付く機会が訪れるかもしれません。今後、外的な進展が訪れる前に、お互いの心の準備が整い、より深い絆が形成されるでしょう。この内面的なプロセスを経て、2人は新しい理解のもとで関係を再構築し、さらに強い信頼と共感の関係が生まれることが期待されます。',
];

//------------------------------------------------------------
// # 10 運命の輪 正位置 好機や上昇
cardsText.upright['10-WheelOfFortune'] = [

'「運命の輪」の正位置は「好機」「変化」「上昇」を象徴し、新しいチャンスやポジティブな変化が期待されます。',

// ### あなたの気持ち  
'あなたは、現在の関係において新たなチャンスが訪れることに対して非常にポジティブな感情を抱いています。運命の輪が回り出し、これまでの努力や忍耐が実を結ぶ時が近づいていると感じています。これまでの経験や苦労が今の自分にとっての強みとなり、相手との関係に新たな展望を開く好機として捉えています。あなたは、今後の関係の発展に対して希望を持ち、より良い未来を目指して前向きなエネルギーを注ぎ込もうとしています。この変化を大切にし、自らも関係に積極的に関与していきたいという強い意志が感じられます。',

// ### 相手の気持ち  
'相手は、あなたとの関係において新たな展望を感じており、運命の輪が回り始めたことに対して期待感を持っています。これまでの時間を振り返り、良いことも悪いことも含めた経験が、今の関係において大切な意味を持っていると理解しています。相手は、過去の出来事から学んだ教訓を生かし、より良い関係を築いていくための準備が整いつつあります。新しいチャンスが近づいていることに気づき、その機会を生かすために、あなたとのコミュニケーションを深めたいと願っています。相手もまた、この流れを利用して関係をより豊かなものにしたいと考えているでしょう。',

// ### 2人の現状  
'現在、2人の関係は大きな変化の兆しが見え始めており、運命の輪が好機をもたらしています。これまでの努力が実を結ぶ時期が近づいており、お互いが成長し、深い理解を得るための絶好のチャンスが訪れています。現在の状況は、一見すると静かな時間かもしれませんが、内面的には大きな転換点に向かう準備が整いつつあります。お互いが過去を振り返りつつも、未来に向かって新たな一歩を踏み出そうとしている状態です。コミュニケーションを通じて、お互いの期待や願望を再確認し、関係をさらに深化させる準備を整えているでしょう。',

// ### 2人の近い未来  
'近い未来において、2人の関係は運命の流れに乗り、驚くほどのポジティブな変化が訪れるでしょう。運命の輪の影響により、今までの努力が実を結び、互いにとって有意義な出来事やチャンスが次々と舞い込む可能性が高まります。この変化により、互いの絆は一層強まり、愛情や信頼が深まっていくでしょう。また、未来に向けた明確なビジョンが共有され、2人の関係が新たな段階へと進化することが期待されます。この運命の流れを大切にし、共に成長していく姿勢が、さらに幸福な関係を築く基盤となるでしょう。',
];

//------------------------------------------------------------
// # 11 正義 正位置 好機や上昇
cardsText.upright['11-Justice'] = [

'「正義」の正位置は「公平」「バランス」「真実」を象徴し、正直さや公正さが重要な要素として強調されます。',

// ### あなたの気持ち  
'あなたは、相手との関係において公平さや正義を強く求めている段階にあります。感情的な部分だけでなく、互いに対して誠実であることが重要だと感じており、正直なコミュニケーションを心掛けています。あなたは、相手との関係を深めるためには、双方の意見や感情を尊重し、バランスを保つことが欠かせないと理解しています。この気持ちがあるため、互いにとって公正な判断を下し、未来に向かって健全な関係を築くための基盤を作りたいと考えています。あなたは、愛情と誠実さが交わる関係を理想としており、その実現に向けて努力する姿勢が見えます。',

// ### 相手の気持ち  
'相手は、あなたとの関係において正義や公平さを非常に重視しています。感情的な側面を大切にしつつも、論理的な判断や公平な視点から物事を見つめ直す姿勢が見受けられます。相手は、自分の気持ちや意見だけでなく、あなたの立場や気持ちも大切にしたいと考えており、コミュニケーションを通じてお互いを理解し合おうとしています。このような思慮深さが、相手の心の中で大切な価値観となっており、2人の関係をより健全なものにするための努力が見えます。また、相手も未来に向けて公正な決断をするための準備を進めている様子です。',

// ### 2人の現状  
'現在の2人の関係は、正義のカードが示すように、誠実さと公平さが根底にある非常に安定した状況です。お互いが相手の意見や感情を尊重し、建設的なコミュニケーションを図ることで、関係がさらに深まっています。表面的な感情だけでなく、互いに真実を追求する姿勢が強く、共に成長しようとする意欲が見られます。この時期は、過去の誤解や対立を解消するための良い機会でもあり、お互いの信頼を再構築するための基盤が形成されています。2人の間には、互いを理解し合い、支え合う姿勢が強く現れています。',

// ### 2人の近い未来  
'近い未来において、2人の関係はさらに深化し、公平さと誠実さが支配する明るい展望が見えてきます。お互いが正直に思いを語り合うことで、誤解や不安を取り除くチャンスが訪れるでしょう。このプロセスを通じて、関係はより健全なものとなり、双方が納得する形で新しい目標を設定することができるかもしれません。未来に向けての選択や決断が訪れる際も、互いに公正であることが重要となり、その結果、2人の絆は強化されるでしょう。この正義の流れを大切にし、関係のバランスを保ちながら、幸福な未来を共に歩んでいく姿が期待されます。',
];

//------------------------------------------------------------
// # 12 吊るされた男 正位置 忍耐や試練
cardsText.upright['12-TheHangedMan'] = [

'「吊るされた男」の正位置は「忍耐」「試練」「視点の変化」を象徴し、一時的な停滞や挑戦が重要な意味を持つことを示しています。',

// ### あなたの気持ち  
'あなたは、現在の関係において忍耐が求められる状況に直面しています。この試練に対して少し戸惑いを感じながらも、相手との絆を深めるために必要な過程であると理解しています。短期的な結果を求めるのではなく、長期的な成長を重視し、今は静かに状況を受け入れることが大切だと認識しています。あなたは、忍耐を通じて得られる深い理解や洞察を期待しており、視点を変えることで新たな可能性を見出すことに意欲を燃やしています。この過程が、最終的にはより強固な関係を築くためのステップになると信じています。',

// ### 相手の気持ち  
'相手も、2人の関係において試練や忍耐の時期を感じています。現在の状況に対して少し消極的な気持ちを抱きながらも、関係が進展するためにはこの過程が不可欠であると認識しています。相手は、今後の関係の発展に向けて自分自身の視点を見直す必要があると感じ、内面的な成長を目指す姿勢が見えます。忍耐を強いられる時期であるため、相手は少し内向的になっているかもしれませんが、最終的にはこの経験が2人の絆を強化し、より深い信頼を築くきっかけになると考えています。',

// ### 2人の現状  
'現在、2人の関係は試練の時期にあり、どちらか一方が優位に立つのではなく、共に忍耐が求められる状況です。この一時的な停滞感が、お互いに深い内面的な成長を促していることを理解することが重要です。お互いの立場や気持ちを理解するために、対話が必要とされており、コミュニケーションの中でお互いの視点を尊重する姿勢が大切です。この時期は、一見困難に見えるかもしれませんが、実は2人の関係を再評価し、深めるための貴重な機会でもあります。忍耐強くこの状況を乗り越えることで、より強い絆を築くことができるでしょう。',

// ### 2人の近い未来  
'近い未来において、2人の関係は試練を乗り越えることで新たな展望を迎えるでしょう。忍耐の時期が終わりを迎え、互いに新たな視点や理解を持って関係を再構築する機会が訪れます。これまでの経験を通じて得た教訓や洞察が、今後の関係において大いに役立つことが期待されます。この時期は、過去の出来事から学び合うことで、より深い信頼と愛情が育まれるでしょう。新たなスタートを切る準備が整い、2人の関係はより強固なものへと進化していく可能性があります。この変化を前向きに受け入れ、互いの成長を喜び合える関係が築かれるでしょう。',
];

//------------------------------------------------------------
// # 13 死神 正位置 損失や死
cardsText.upright['13-Death'] = [

'「死神」の正位置は「変化」「終わり」「新たな始まり」を象徴し、過去のものが終わり、新たなステージへと進むことを示しています。',

// ### あなたの気持ち  
'あなたは、現在の関係において何かが終わることに対して複雑な感情を抱いています。別れや損失というテーマが浮かび上がり、不安や悲しみを感じる一方で、新たな可能性に対する期待感も持っています。この終わりがもたらす変化に対し、あなたは自らの感情を整理することが求められている状況です。過去を振り返り、これまでの経験から学んだことを次に生かしたいと考えており、終わりを受け入れることで新たな一歩を踏み出す準備をしています。あなたの心の中では、失ったものに対する惜しさと、新たな希望との間で揺れ動いている状態です。',

// ### 相手の気持ち  
'相手は、2人の関係において終わりが近づいていることを感じており、そのことに対する重苦しさや切なさを抱えています。過去の出来事や感情に執着することなく、新たなスタートが必要であると理解しているものの、心の中では不安が大きく、変化に対する恐れも感じています。相手は、何が終わろうとしているのかを理解し、その終わりが2人にとってどのような意味を持つのかを考え続けています。このような複雑な感情を抱える中で、相手は少しずつ受け入れ、前に進む準備をしているようです。また、新たな始まりが来ることを心のどこかで期待している部分もあるでしょう。',

// ### 2人の現状  
'現在、2人の関係は変化の真っ只中にあり、過去の状態が終わりを迎えようとしています。この変化は避けられないものであり、どちらか一方が変化を望んでいるわけではなく、自然な流れとして受け入れられています。お互いの間には、感情の整理やコミュニケーションが必要な状況が生まれており、特に過去の出来事や関係性の見直しが求められています。この試練は一見ネガティブに思えるかもしれませんが、実際には2人が新たなステージに進むための重要なプロセスでもあります。互いに理解し合い、支え合うことで、次の段階へ進むための基盤を築くことができるでしょう。',

// ### 2人の近い未来  
'近い未来において、2人の関係は新たな始まりを迎えることが期待されます。過去の終わりがもたらす痛みを乗り越え、互いに新しい未来に向かって進むためのステップが用意されています。この変化を受け入れることで、2人は新たな視点や理解を持って関係を再構築し、より良い方向へ進む可能性が高まります。また、過去の経験を活かして、より深い絆や信頼を築くための機会が訪れるでしょう。失ったものの代わりに、新たな幸せや充実感を得ることができるかもしれません。この流れを大切にし、共に成長し合う姿勢が求められています。',
];

//------------------------------------------------------------
// # 14 節制 正位置 安定や協力
cardsText.upright['14-Temperance'] = [

'「節制」の正位置は「安定」「調和」「協力」を象徴し、相互理解やサポートが重要なテーマとなります。',

// ### あなたの気持ち  
'あなたは、現在の関係において安定感を強く求めています。これまでの経験から、感情の起伏を抑え、穏やかに接することが重要だと感じています。相手との関係を築く中で、お互いに支え合い、協力することで信頼を深めたいという思いがあります。あなたは、今の状況を大切にし、感情のバランスを保ちながら相手とのコミュニケーションを円滑に進める努力をしています。また、心の中では「相手との絆をさらに深めたい」という願いが強く、共に未来を築くことに希望を抱いている状態です。',

// ### 相手の気持ち  
'相手は、2人の関係において安定を重視しており、あなたとの絆を大切にしたいと考えています。最近のコミュニケーションの中で、相手は協力の精神を強く感じており、お互いの意見や気持ちを尊重することが関係をさらに良くするために必要だと理解しています。安定した関係を求める中で、時には妥協や調整が必要であることも認識しており、関係を維持するための努力を惜しまない姿勢が見えます。このような思いから、相手は今後もあなたと共に歩むための最善策を探っている状態です。',

// ### 2人の現状  
'現在、2人の関係は非常に安定しており、お互いに協力し合う姿勢が感じられます。日常の中でのコミュニケーションがスムーズに行われており、相手の気持ちを理解しようとする努力が双方に見られます。この時期は、感情的な対立も少なく、互いの意見を尊重しながら関係を築いていくための良い機会です。お互いにバランスを保ちながら、信頼を深めるための基盤が整っています。この調和の時期を大切にし、さらなる理解と愛情を育むためのステップとして捉えることができます。',

// ### 2人の近い未来  
'近い未来において、2人の関係はさらなる安定と調和を迎える可能性が高いです。お互いの理解が深まり、協力し合うことでより強い絆が築かれるでしょう。この時期は、感情的な成長や発展が期待され、お互いに支え合うことで新たな可能性が開けていきます。過去の経験を生かし、良好なコミュニケーションを保つことで、将来に対する希望も高まります。特に、一緒に取り組むプロジェクトや目標があれば、その成果を共有し合い、喜びを分かち合うことで、2人の絆が一層強くなることが期待されます。この流れを大切にし、未来への道を共に歩む準備が整いつつあるでしょう。',
];

//------------------------------------------------------------
// # 15 悪魔 正位置 誘惑や裏切り
cardsText.upright['15-TheDevil'] = [

'「悪魔」の正位置は「誘惑」「依存」「裏切り」を象徴し、深い感情的な試練や選択が浮かび上がります。',

// ### あなたの気持ち  
'あなたは、現在の関係において強い誘惑と混乱を感じています。このカードが示すように、相手との関係が自分にとってどれほどの影響を持っているかを理解しながらも、時にはそれに依存してしまうことに対する不安も抱えています。相手に対する愛情や魅力がある一方で、それが自身の精神的な健康に影響を及ぼすことを心配しています。このような矛盾した気持ちの中で、あなたは相手との関係を維持し続けることが果たして自分にとって正しい選択なのかを真剣に考えています。また、裏切りや信頼の欠如といったテーマも心の中で反響しており、今後の選択に大きな影響を与える可能性があります。',

// ### 相手の気持ち  
'相手は、2人の関係において強い魅力と同時に不安を感じています。悪魔のカードが示す通り、相手はあなたに対する強い感情を持ちながらも、その関係が自分にとってどれだけ健全かを疑問視しています。誘惑に駆られる瞬間や、裏切りに対する恐れが心の中で交錯し、相手は自己制御と欲望の狭間で揺れ動いています。このような葛藤は、相手の心を複雑にし、時には距離を置くことを考えさせる要因となっています。また、相手は自らの欲望に忠実でありたいと願う一方で、責任感や倫理的な観点から目を背けることもできず、非常に苦しい状況にあることが伺えます。',

// ### 2人の現状  
'現在、2人の関係は複雑な状況にあります。悪魔のカードが示す通り、相互の欲望や誘惑が大きな影響を与えており、一見魅力的に見える部分がある一方で、暗い影が関係を覆っています。お互いに対する愛情があるものの、同時に裏切りや不安、依存の感情が絡み合っており、心の中で葛藤が生まれています。特に、コミュニケーションが滞りがちになり、誤解や不信感が育つ可能性があります。この状況を放置すると、関係がさらに悪化するリスクがあるため、真剣に向き合う必要があります。お互いに何を望んでいるのか、どのようにこの状況を乗り越えられるのかを考えることが求められています。',

// ### 2人の近い未来  
'近い未来において、2人の関係には大きな変化が訪れる可能性があります。悪魔のカードが示す誘惑や裏切りの要素は依然として存在しますが、それにどう向き合うかが重要な分岐点となるでしょう。このまま誘惑に流されるのか、それとも互いに真実の気持ちを確認し、裏切りを防ぐために協力するのかは、2人の選択にかかっています。困難な状況を乗り越えるためには、誠実なコミュニケーションと自己反省が不可欠です。この試練を通じて、信頼を再構築し、より強い絆を築くための機会にもなり得ます。最終的には、この経験が2人にとって成長の糧となり、関係が一層深まることを期待しています。',
];

//------------------------------------------------------------
// # 16 塔 正位置 崩壊や悲劇
cardsText.upright['16-TheTower'] = [

'「塔」の正位置は「崩壊」「悲劇」「ショック」を象徴し、急激な変化や試練が訪れることを示唆しています。',

// ### あなたの気持ち  
'あなたは、現在の関係が危機的な状況にあることを強く感じており、不安と混乱に包まれています。塔のカードが示すように、何か大きな変化や崩壊の予感があり、そのために自分の感情が揺れ動いている状態です。愛情や信頼が脆くなっていることを理解しながらも、その一方で相手との関係を保ちたいという葛藤が心の中で渦巻いています。あなたは、今後どうすれば良いのか、どのようにこの状況を乗り越えられるかを真剣に考えており、別れや裏切りの恐れが常に心の中に影を落としています。過去の幸せな思い出が逆に切なさを増し、今後の選択に対する迷いが強まっている状態です。',

// ### 相手の気持ち  
'相手は、2人の関係が崩壊する危機に直面していることを感じ取っており、恐れや混乱が心に広がっています。塔のカードが示すように、相手はこの状況に対して受け入れがたい感情を抱いています。愛情や絆が壊れる可能性があることを認識し、どうにかして関係を修復したいという願望を持ちながらも、自らの過去の選択や行動に対する後悔が心を圧迫しています。また、相手は自分の感情を整理する余裕がなく、何が本当に大切なのかを見極めることが難しいと感じています。この不安定な状況に対して、相手は何かしらの解決策を見つけたいと望んでいるものの、どう行動すれば良いかの判断ができずにいます。',

// ### 2人の現状  
'現在、2人の関係は非常に危険な状況にあります。塔のカードが示す通り、関係の基盤が揺らぎ、崩壊の危機が迫っていると感じられます。コミュニケーションは停滞しており、お互いの気持ちが伝わらないまま不安が募っています。過去の出来事や誤解が原因で、信頼感が薄れ、互いに防御的な態度をとりがちです。この状況は、解決を求める声が聞こえないことにより、ますます悪化する可能性があります。お互いが抱える不安や恐れが強く、前に進むための足かせになっているのが現実です。特に、過去の幸福な瞬間と現在の悲劇的な状況の対比が、精神的な苦痛を一層深めているといえるでしょう。',

// ### 2人の近い未来  
'近い未来において、2人の関係には大きな変化が訪れることが予想されます。塔のカードが示す通り、この変化は時にはショックや痛みを伴うかもしれませんが、崩壊は新たな始まりを意味する場合もあります。この機会にお互いの真の感情や本音を話し合うことが求められています。もし、対話ができれば、関係を再構築するための土台を作ることが可能です。反対に、問題を放置した場合、関係の破綻が避けられないかもしれません。この未来を迎えるにあたり、双方の覚悟と誠実なコミュニケーションが必要不可欠です。崩壊が必ずしも悪い結果に繋がるわけではなく、真の意味での解放と成長のチャンスとして受け入れることも一つの選択肢となるでしょう。',
];

//------------------------------------------------------------
// # 17 星 正位置 希望や可能性
cardsText.upright['17-TheStar'] = [

'「星」の正位置は「希望」「可能性」「癒し」を象徴し、明るい未来を示唆しています。',

// ### あなたの気持ち  
'あなたは、相手との関係に対して希望を持っており、未来に対する期待が高まっています。星のカードが示す通り、過去の困難や問題を乗り越え、今は新たな可能性が開けていると感じています。この気持ちは、互いに支え合うことで強まっていくものであり、相手との絆がより深まることを願っています。また、感情的な癒しも求めており、相手との関係を通じて心が満たされることを期待しています。あなたは、相手との未来に夢を描きながら、ポジティブなエネルギーを持って前進しようとしています。この希望の光が、今後の行動や選択に大きく影響するでしょう。',

// ### 相手の気持ち  
'相手は、2人の関係に対して希望を持っていることが伺えます。星のカードが示すように、相手は未来に対する楽観的な視点を持ち、あなたとの関係が新たなステージに進む可能性を感じています。この気持ちは、相手にとって心の安らぎや満足感をもたらしており、共に過ごす時間を大切にしたいと願っています。さらに、相手はお互いの成長を見守りたいと思っており、共に夢を追いかけることができる関係を築きたいと考えています。また、過去のトラブルを乗り越えたことで、お互いの絆がより強くなることを信じており、この希望が相手を行動に駆り立てる要因になっています。',

// ### 2人の現状  
'現在、2人の関係は希望に満ちた状態にあります。星のカードが示す通り、過去の困難を乗り越えたことで、お互いに対する理解や信頼が深まっています。この状況は、愛情や絆を再確認する機会となっており、互いに支え合う姿勢が強まっています。コミュニケーションも活発になり、お互いの気持ちや未来について話し合うことで、共通の目標を見出しつつあります。このようなポジティブなエネルギーが関係を一層明るく照らし、未来への期待感を高めています。ただし、注意すべき点として、過去の問題が再燃することもあり得るため、引き続きお互いに誠実でいることが重要です。',

// ### 2人の近い未来  
'近い未来において、2人の関係にはさらなる希望が待っているでしょう。星のカードが示す通り、互いにサポートし合いながら新たな目標に向かって進むことができる可能性があります。お互いの夢やビジョンを尊重し合いながら、共に成長していく姿勢が見られるでしょう。また、コミュニケーションが活発になることで、より深い絆が築かれることが期待されます。この未来は、過去の経験を活かし、相互の理解を深める機会となるでしょう。ただし、相手の気持ちや状況をしっかりと理解し、柔軟に対応することが求められます。この希望の時期を大切にし、2人の関係がより良い方向に進むことを願っています。',
];

//------------------------------------------------------------
// # 18 月 正位置 危険や誘惑
cardsText.upright['18-TheMoon'] = [

'「月」の正位置は「危険」「誘惑」「不安」を象徴し、複雑な感情や潜在的な問題を暗示しています。',

// ### あなたの気持ち  
'あなたは、相手との関係に対して不安や疑念を抱いています。「月」のカードが示すように、直感が危険信号を発していると感じているため、心の中に迷いや疑念が渦巻いています。特に、相手の行動や言葉に対して信頼を失いかけており、その結果、関係が不安定になることを恐れています。また、誘惑や誤解が生じやすい状況にいることを理解し、相手とのコミュニケーションの必要性を痛感しています。このような状況下で、あなたは過去の出来事や感情を振り返り、どのように行動するべきか慎重に考えています。心の中には愛情があるものの、その愛が試練に直面していると感じており、未来への不安が強まっています。',

// ### 相手の気持ち  
'相手は、2人の関係に対して複雑な感情を抱いています。「月」のカードの影響により、相手も不安を感じているものの、それを表に出すことができずにいます。感情的な葛藤や迷いが心に渦巻いており、今後の関係についてどうすべきかを模索している状態です。また、相手は自分自身の内面に向き合う必要性を感じており、過去の経験やトラウマが関係に影を落とすことを恐れています。この不安感から、相手は自分の気持ちを隠そうとしがちですが、心の奥底では関係の未来に対して不安を抱えていることは明らかです。自らの感情を整理するための時間が必要だと感じつつ、あなたとの絆をどうにかして守りたいと思っています。',

// ### 2人の現状  
'現在、2人の関係は非常に不安定な状況にあります。「月」のカードが示す通り、互いの気持ちや考えがすれ違い、コミュニケーションが不足していることが問題となっています。過去の出来事や誤解が関係に影響を及ぼしており、互いに疑念を抱く場面が増えています。このため、心の中にある不安が積み重なり、さらに関係が悪化する危険性があります。また、互いに愛情を持ちながらも、その愛が試練にさらされていることを痛感している状況です。共に過ごす時間が減り、感情のすれ違いが生じやすくなっており、このまま放置すると、関係の崩壊を招く恐れがあるため、早急な解決策が求められています。',

// ### 2人の近い未来  
'近い未来において、2人の関係には試練が待ち受けています。「月」のカードが示すように、今後も誘惑や不安が影響を及ぼす可能性があります。特に、互いの気持ちを誤解しやすい状況が続くため、コミュニケーションが鍵となるでしょう。この期間、過去の出来事を振り返り、どのように改善できるかを話し合うことが重要です。もし、誤解を解消し、お互いの真意を理解できれば、関係の回復が期待できます。しかし、反対に問題を放置した場合、関係はさらに悪化し、最終的には大きな亀裂を生じることもあり得ます。この時期を乗り越えるためには、慎重に行動し、心を開いてお互いの気持ちを大切にすることが必要です。',
];

//------------------------------------------------------------
// # 19 太陽 正位置 成功や活気
cardsText.upright['19-TheSun'] = [

'「太陽」の正位置は「成功」「活気」「喜び」を象徴し、非常にポジティブなエネルギーを暗示しています。',

// ### あなたの気持ち  
'あなたは、相手との関係に対して非常にポジティブな感情を抱いています。「太陽」のカードが示すように、幸せな瞬間や明るい未来を感じており、自信に満ちた気持ちで相手との絆を深めようとしています。この関係が持つ可能性に心を躍らせており、互いにサポートし合うことで、さらなる成功を手に入れられると信じています。あなたは、相手に対する愛情や感謝の気持ちを強く感じており、その思いをしっかりと伝えたいと考えています。また、共に過ごす時間を楽しむことが、より一層この関係を深めると確信しており、未来への期待感にあふれています。',

// ### 相手の気持ち  
'相手もまた、2人の関係に対して明るい気持ちを抱いています。「太陽」のカードが表すように、相手はあなたとの関係を楽しんでおり、共にいることが自分にとっての喜びであると感じています。ポジティブなエネルギーに満ちており、互いに高め合うことができる関係だと確信しています。相手は、あなたの存在が自分の生活にどれほどの明るさをもたらしているかを理解しており、その感謝の気持ちを伝えることに喜びを感じています。また、未来に対して楽観的であり、2人の絆がさらに深まることを望んでいます。相手は、共に新しい経験をすることで、関係がさらに強固になると期待しています。',

// ### 2人の現状  
'現在、2人の関係は非常に良好な状態にあります。「太陽」のカードが示す通り、互いに明るく前向きなエネルギーを持ち寄り、支え合うことで関係が深まっています。共に過ごす時間が楽しく、笑顔が絶えない瞬間が多く、信頼関係も強まっています。また、互いに理解し合い、サポートし合う姿勢が感じられ、このまま進めばさらなる成功を収めることができるでしょう。特に、コミュニケーションが円滑であり、心の内を開いて話し合うことができている点が大きな強みです。この関係のもとで、互いに成長し、新たな目標に向かって進んでいることが感じられ、未来への希望が高まっています。',

// ### 2人の近い未来  
'近い未来において、2人の関係はさらなる発展を遂げるでしょう。「太陽」のカードが暗示する通り、成功と喜びに満ちた瞬間が訪れる予感があります。共に新しいプロジェクトや冒険に挑戦することで、さらに強い絆を築くことができるでしょう。この期間、互いの理解が深まり、感情的な結びつきがより強くなります。また、友人や家族との関係も良好に保たれ、周囲からのサポートも得られることで、安心感を感じながら関係を進めていくことができるでしょう。近い未来には、祝福すべきイベントや喜びの瞬間が訪れる可能性が高く、互いにとって特別な思い出を作る機会が訪れると期待されます。',
];

//------------------------------------------------------------
// # 20 審判 正位置 復活や更新
cardsText.upright['20-Judgement'] = [

'「審判」の正位置は「復活」「更新」「再生」を象徴しており、新たな局面をもたらすことが期待されますす。',

// ### あなたの気持ち  
'あなたは、相手との関係において強い期待と希望を抱いています。「審判」のカードが示すように、過去の出来事や誤解が解消され、関係の再構築を望む気持ちが高まっています。あなたは、再出発を図るための準備を整え、新しいスタートを切ることに意欲的です。この気持ちは、相手への愛情や思いやりから生まれており、共に未来を築くために必要な変化を受け入れようとしています。また、自分自身の成長を通じて、関係をより深めたいという願望も強く、心の中で新たな可能性を探っています。',

// ### 相手の気持ち  
'相手もまた、関係の復活に対して期待を寄せています。「審判」のカードが表すように、過去の出来事から学び、より良い関係を築くために行動しようとしています。相手は、あなたとの間にあった課題を乗り越え、再び絆を深めたいと考えているのです。この思いは、相手にとって非常に重要な意味を持ち、以前とは違う視点で関係を見つめ直しています。相手は、あなたとの関係が自分自身の成長にもつながると信じ、共に未来に進むことにワクワクしています。この新たな始まりに対して、強い意欲を抱いていることでしょう。',

// ### 2人の現状  
'現在、2人の関係は再生の過程にあります。「審判」のカードが示すように、過去のトラブルや誤解が解消されつつあり、関係の再構築に向けた歩みが始まっています。2人はお互いの気持ちを確認し合い、過去を振り返ることで新たな理解を得ています。この状況は、相手とのコミュニケーションを深める良い機会であり、互いの成長を促す要素となるでしょう。関係の改善に向けた意識が高まり、お互いの思いやりをもって接することで、信頼感が回復しつつあります。全体として、関係は前向きな方向に進んでいると言えます。',

// ### 2人の近い未来  
'近い未来において、2人の関係はさらなる進展が期待されます。「審判」のカードが示す通り、復活や再生の流れが強まる中で、互いの気持ちを再確認し、信頼関係が深まるでしょう。この時期、2人は共に新たな目標を設定し、それに向かって協力していくことになると思われます。また、過去の経験を踏まえたうえで、より成熟した関係を築くことができるでしょう。今までの反省を生かしながら、喜びや幸せを分かち合う瞬間が訪れる予感があります。全体として、2人の関係は再び明るい未来に向かって進んでいくことでしょう。',
];

//------------------------------------------------------------
// # 21 世界 正位置 完全や完成
cardsText.upright['21-TheWorld'] = [

'「世界」の正位置は「完成」「達成」「統合」を象徴し、充実した状態にあることを示唆しています。',

// ### あなたの気持ち  
'あなたは、相手との関係に対して強い満足感と充実感を抱いています。「世界」のカードが示すように、自分の人生においてこの関係が非常に重要な位置を占めていると感じているのです。あなたは、互いの成長や支え合いを通じて、愛情が深まったことに喜びを感じています。また、2人の関係が一つの完成を迎えたことを実感し、将来に対しても期待が高まっています。過去の経験や課題を乗り越え、今の状態を維持したいという思いが強いです。この感情は、相手に対する信頼や愛情が強まった証でもあり、2人の関係が成熟したものであることを示しています。',

// ### 相手の気持ち  
'相手もまた、2人の関係に対して非常にポジティブな気持ちを抱いています。「世界」のカードが表すように、達成感と満足感を感じており、関係の成熟を喜んでいます。相手は、あなたとの時間を大切に思い、共に過ごす瞬間が何よりも価値のあるものであると認識しています。また、この関係が互いの人生にとってどれほど大切であるかを理解し、より一層愛情を注ぎたいと考えています。相手は、自分自身の成長と共に、2人の関係もさらに深いものへと発展させたいという意欲を持っており、共に未来を築くことを楽しみにしています。',

// ### 2人の現状  
'現在、2人の関係は非常に安定し、充実した状態にあります。「世界」のカードが象徴するように、これまでの経験を通じて得た絆が強固なものになっています。互いに理解し合い、支え合う姿勢が見られ、日常生活においても協力しながら共に歩んでいます。2人は、各自の目標や夢を尊重しながら、お互いを励まし合う関係が築かれており、この状態は長続きすることが期待されます。また、今後の関係の発展についても自然な流れで進んでいくでしょう。2人の間には、愛情と信頼がしっかりと根付いており、今後の可能性に対してもポジティブな気持ちで満ちています。',

// ### 2人の近い未来  
'近い未来において、2人の関係はさらなる発展を遂げることが予測されます。「世界」のカードが示すように、この関係は今後も進化を続け、さらに深い愛情や絆が築かれるでしょう。互いの成長を支え合うことで、これまで以上に信頼関係が強まり、共通の目標に向かって進んでいく可能性が高いです。2人は、より良い未来を見据え、協力し合いながら新たな挑戦に向かうことでしょう。この時期は、共に達成感を味わう瞬間が訪れたり、喜びを分かち合う出来事が起こる予感があります。全体として、2人の関係は充実し、喜びや幸せに満ちた未来へと向かっていくことでしょう。',
];

//------------------------------------------------------------
// # 00 愚者 逆位置 見切り発車
cardsText.reverse['00-TheFool'] = [

'「愚者」の逆位置は「見切り発車」「無計画」「軽率」を象徴し、計画なしに行動を起こすことによるリスクや失敗を暗示しています。',

// ### あなたの気持ち  
'あなたは現在の関係に対して戸惑いを感じています。「愚者」の逆位置が出たことで、相手との関係が無計画で進んでいるのではないかという不安が芽生えているのです。先に進むべきか、立ち止まるべきか悩んでおり、特に相手の行動や意図が不明確なため、あなたは自己防衛の感情を抱いています。この状況において、あなたは過去の経験から慎重になりつつも、同時に新たな出発に対する期待感も抱いています。過度な期待を持たずに現状を見極めようとしている姿勢が感じられますが、心の中では相手との関係が安定することを願っています。',

// ### 相手の気持ち  
'相手はあなたとの関係において、無計画さを感じている様子が伺えます。「愚者」の逆位置が示すように、軽率な行動や言動によって、相手は関係が不安定になっていることを実感しています。何か新しいことを始めようとしているものの、準備不足や見切り発車の状態にあるため、相手は戸惑いを感じています。また、過去の失敗が影を落としており、今後どう行動すべきかを考え直す必要があると感じています。こうした不安から、相手はあなたとの関係に対して消極的になりがちで、より深い絆を築くためには何か工夫が必要だと感じています。',

// ### 2人の現状  
'現在、2人の関係は見切り発車の状態にあります。「愚者」の逆位置が示す通り、互いに明確な目的や計画を持たずに進んでいるため、コミュニケーションの不足や誤解が生じやすい状況です。このため、関係は不安定で、時折不満や不安が生まれることがあります。また、過去の問題が尾を引いているため、心のどこかでつまずくことへの恐れも感じられます。この現状を打破するためには、双方がしっかりとしたコミュニケーションを取ることが必要です。お互いの考えや気持ちを理解し合うことで、今の状態を改善するチャンスがあるでしょう。',

// ### 2人の近い未来  
'近い未来において、2人の関係は無計画な状況から脱却する必要があります。「愚者」の逆位置が示唆するように、見切り発車のままでいると、さらなる誤解や問題を引き起こす可能性があります。今後は、互いに冷静になり、状況を見直すことが求められています。あなたと相手が共に意見を交換し合うことで、未来に向けての計画や目標を設定できる可能性が高まります。お互いのニーズや期待を理解し合い、協力することで、関係の安定が図れるでしょう。このプロセスを経ることで、少しずつ信頼が再構築され、より良い関係へと向かうことが期待されます。',
];

//------------------------------------------------------------
// # 01 魔術師 逆位置 能力の不足
cardsText.reverse['01-TheMagician'] = [

'「魔術師」の逆位置は「能力の不足」や「潜在力が発揮されない状況」を象徴し、自己の力やスキルに対する自信のなさが現れ、期待される役割を果たせない状態を示しています。',

// ### あなたの気持ち  
'あなたは、相手との関係が思うように進んでいないことに対して、苛立ちや不安を感じています。「魔術師」の逆位置が示すように、あなたは自分の努力や能力がうまく発揮されていない、または相手に伝わっていないと感じているようです。このため、関係の進展が停滞していることに対し、焦りや不満を抱いています。しかし、自分自身の行動にも疑念を感じており、どのように接すれば良いのか分からなくなっている状態です。あなたは、もっと自分の感情や考えを相手に伝えるべきだと思いつつも、その方法に自信が持てていないのかもしれません。',

// ### 相手の気持ち  
'相手もまた、2人の関係において満たされない部分を感じています。「魔術師」の逆位置が示す通り、相手は自分の力不足や、あなたとの間にある何かがうまく機能していないことに気付いています。しかし、その原因を明確に理解できておらず、どう改善すればよいのかが分からない状況です。相手は、表面的には冷静さを保っていますが、内心では自信を失っており、関係が停滞していることに悩んでいます。このため、今の状況から抜け出すための決断ができず、消極的な態度を取っているかもしれません。',

// ### 2人の現状  
'現在の2人の関係は、停滞しているようです。「魔術師」の逆位置が表すように、お互いに何かを引き出そうとしているものの、十分な能力や行動力が不足しており、関係が思うように進んでいません。コミュニケーションのすれ違いが生じ、互いの期待に応えられていない状況です。さらに、どちらかがリーダーシップを取ることなく、関係が自然に進展することを期待しているため、ますます混乱を引き起こしています。このままでは、関係のさらなる悪化が予想されるため、状況を打開するためには積極的な行動が必要です。',

// ### 2人の近い未来  
'今後の2人の関係において、現状の停滞感がしばらく続く可能性があります。「魔術師」の逆位置が示唆する通り、関係の進展を期待するには、互いの能力や意識の変化が必要ですが、それがすぐに実現するのは難しいかもしれません。今のままでは、お互いが何を求めているのかを理解し合えず、関係においてますます行き詰まる可能性があります。ただし、相手や自分自身の行動を見直し、具体的な努力をすることで、徐々に改善の兆しが見えてくるかもしれません。積極的に問題に取り組む姿勢が重要となります。',
];

//------------------------------------------------------------
// # 02 女教皇 逆位置 身勝手さ
cardsText.reverse['02-TheHighPriestess'] = [

'「女教皇」の逆位置は「身勝手さ」や「感情的な不安定さ」を象徴し、自分の内面にしか目を向けず、他者の気持ちを無視した行動を暗示しています。',

// ### あなたの気持ち  
'あなたは、相手との関係において不満や不安を感じており、それが行動や言葉に現れ始めています。「女教皇」の逆位置が示すように、あなたは自分の感情に振り回されており、冷静な判断ができていない状態です。相手の行動に対して過剰な反応を示したり、自分の欲求を優先することで、関係においてバランスを崩しがちです。本来は深い理解を求めているものの、今はその気持ちをうまく伝えられず、誤解を招いてしまっているかもしれません。あなたは、自分の感情を整理し、冷静さを取り戻す必要があります。',

// ### 相手の気持ち  
'相手もまた、あなたとの関係においてフラストレーションを感じています。「女教皇」の逆位置が表すように、相手はあなたの感情的な態度や、自己中心的な行動に対して困惑し、関係をどう改善すべきか悩んでいる様子です。相手は基本的に冷静でいたいと考えていますが、あなたの態度に影響され、自身も感情的になることが増えているかもしれません。相手は理解しようという姿勢を持っていますが、現状ではその努力が報われず、次第に距離を置こうとする傾向が見え始めています。',

// ### 2人の現状  
'2人の関係は、今まさに感情的な混乱に包まれています。「女教皇」の逆位置が示すように、互いの思いやりや理解が不足し、自己中心的な振る舞いが強調されている状態です。コミュニケーションがうまくいかず、誤解や衝突が増える傾向にあります。この状況では、お互いに冷静さを失い、感情に流されやすくなり、問題を解決するどころか、さらに関係が悪化する可能性があります。ここで重要なのは、感情に振り回されず、互いの立場や気持ちを理解しようとする姿勢を持つことです。',

// ### 2人の近い未来  
'近い未来において、2人の関係にはさらなる困難が訪れるかもしれません。「女教皇」の逆位置が示すように、感情的な不安定さや自己中心的な行動が続く限り、関係の改善は難しいでしょう。このままでは、互いに距離を置くような状況になる可能性もあります。ただし、今の状態を乗り越えようとする意志があれば、少しずつでも関係の修復に向けたステップを踏むことができるでしょう。冷静さと共感を持って相手に接することが、未来を変える鍵となります。',
];

//------------------------------------------------------------
// # 03 女帝 逆位置 挫折や虚栄
cardsText.reverse['03-TheEmpress'] = [

'「女帝」の逆位置は「挫折」や「虚栄」を象徴し、過剰な自尊心や他者からの評価にこだわるあまり、実際の関係性が損なわれることを示唆しています。',

// ### あなたの気持ち  
'あなたは、相手との関係において満たされない感情を抱えている状態です。「女帝」の逆位置は、期待していたものが実現せず、失望感を強く感じていることを示しています。あなたは、相手に対して理想を押し付けてしまっているかもしれません。それによって、相手が期待に応えてくれないと感じたとき、自己価値感が揺らいでしまうことがあるでしょう。今、あなたは自分自身を見つめ直し、現実的な視点で関係を見つめることが必要です。',

// ### 相手の気持ち  
'相手は、あなたからの期待や要求に対して、プレッシャーを感じている可能性があります。「女帝」の逆位置が示すように、相手はあなたが示す表面的な欲求や理想に対し、重荷を感じているか、関係が現実のニーズよりも表向きな面に偏っていると感じているでしょう。相手は真の関係を築くためにもっと現実的で深い理解を求めていますが、あなたの態度がそれを妨げているかもしれません。相手は心の中で距離を感じつつあります。',

// ### 2人の現状  
'2人の関係は、表面的な満足や虚栄に支配され、実際には深い結びつきが希薄な状態です。「女帝」の逆位置が示すように、豊かさや愛情が期待されたものの、現実にはそれが満たされておらず、両者の間にはフラストレーションや不満が蓄積しています。互いの本心や感情が十分に共有されていないため、表面的なコミュニケーションで関係を維持しようとしていますが、心の中では深い疎外感が広がっています。このままでは関係の悪化が進む危険性があります。',

// ### 2人の近い未来  
'近い未来において、2人の関係にはさらなる試練が訪れる可能性があります。「女帝」の逆位置は、虚栄心や不満が関係を損なう可能性を示唆しています。もし現実的な問題に目を向けず、感情的な挫折や表面的な満足にとらわれ続けるなら、関係の維持が困難になるでしょう。ただし、ここでお互いに率直なコミュニケーションを試み、真の理解を深める努力ができれば、関係を再構築することも可能です。正直さと協力が、未来のカギとなります。',
];

//------------------------------------------------------------
// # 04 皇帝 逆位置 傲慢や無責任
cardsText.reverse['04-TheEmperor'] = [

'「皇帝」の逆位置は「傲慢さ」や「無責任さ」を象徴し、関係において権力の乱用や不安定さが強調され、周囲との摩擦が生じやすくなることを暗示しています。',

// ### あなたの気持ち  
'あなたは、相手との関係においてフラストレーションや不満を抱えている状態です。「皇帝」の逆位置が示すように、相手がリーダーシップを発揮せず、責任感に欠けていると感じているため、あなた自身が関係をリードしなければならないというプレッシャーを感じています。あなたは、相手に対する不信感が募り、相手の傲慢さや自己中心的な態度に対して苛立ちを覚えている可能性があります。また、相手が期待に応えてくれないため、心の中で距離を取ろうとしているかもしれません。',

// ### 相手の気持ち  
'相手は、自分が関係の中でリーダーシップを取ることを避け、現実から逃げようとしているかもしれません。「皇帝」の逆位置が示すように、相手は自分の役割に対する責任を軽視しており、時には自分勝手な行動を取っている可能性があります。相手は支配的であったり、逆に無関心であったりする一方で、関係を深めるための努力を怠っているでしょう。自分の行動がもたらす結果に対する認識が不足しており、責任感を持つことに対して消極的な態度を示しています。',

// ### 2人の現状  
'現在の2人の関係は、安定感に欠け、支配的な力関係や無責任な態度が関係のバランスを崩しています。「皇帝」の逆位置は、リーダーシップの欠如や関係における不平等を示唆しています。あなたと相手の間には、主導権を巡る対立や意志の不一致があり、それが感情的な摩擦を生んでいる可能性があります。お互いが自分の立場を守ろうとする一方で、関係を健全な方向に進めるための協力が不足しているため、関係が停滞している状態です。',

// ### 2人の近い未来  
'近い未来、2人の関係にはさらなる不安定さが訪れる可能性があります。「皇帝」の逆位置が示すように、支配欲や無責任な行動が続く限り、関係は悪化の一途をたどるかもしれません。相手のリーダーシップ不足や自己中心的な態度が改善されない限り、関係の進展は難しいでしょう。しかし、もし双方がこの状況に気づき、自分たちの役割や責任を再評価することができれば、問題を乗り越えるための道が開ける可能性もあります。',
];

//------------------------------------------------------------
// # 05 法王 逆位置 非常識や閉塞感
cardsText.reverse['05-TheHierophant'] = [

'「法王」の逆位置は「非常識」や「閉塞感」を象徴し、従来の価値観やルールから逸脱した行動や、柔軟性の欠如が関係に影響を与えることを示唆します。',

// ### あなたの気持ち  
'あなたは、現状に対して大きな不満を感じており、閉塞感や自由の制約を強く感じています。相手の行動や態度が「常識」から外れており、信頼を失いつつあることが、あなたの心に不安と疑念を生じさせています。従来の枠に囚われず、新しい視点や価値観を求めている一方で、相手とのコミュニケーションが上手くいかないことに対して無力感を抱いているかもしれません。また、相手の非常識な振る舞いに困惑し、関係をどう修復するか迷っている状態です。',

// ### 相手の気持ち  
'相手は従来の価値観やルールに縛られることを嫌い、自己中心的な考えを強く持っている可能性があります。「法王」の逆位置が示すように、相手は既存の枠組みを打ち破ろうとし、独自のルールや信念を追求していますが、それが関係における摩擦や誤解を生んでいます。また、相手は自身の行動がもたらす影響について深く考えることなく、無意識に閉塞感を増幅させる要因になっている可能性があります。対話の重要性を理解しないまま、自分の意志を優先しているかもしれません。',

// ### 2人の現状  
'2人の現状は、コミュニケーション不足やお互いの考え方の違いによる摩擦が強調されています。「法王」の逆位置は、従来の価値観や道徳から逸脱した行動や考えが原因となり、関係が進展しない状態を示しています。あなたと相手の間には、互いの期待や信念がすれ違っており、協力や理解が難しくなっています。この閉塞的な状況は、互いに譲歩することなく、自分の意見を押し付け合うことで悪化しているようです。安定を取り戻すには、双方が柔軟な態度を持つ必要があります。',

// ### 2人の近い未来  
'今後、関係はさらなる試練に直面する可能性があります。「法王」の逆位置は、非常識な行動や柔軟性の欠如が続く限り、関係の発展が妨げられることを示唆しています。相手が自分の価値観に固執し続ける限り、あなたはますます孤立感や疎外感を感じるかもしれません。しかし、もし双方が状況の改善に向けて努力し、違いを受け入れる姿勢を持つことができれば、閉塞感を打破し、新たな道を切り開くことも可能です。対話と妥協が未来の鍵となるでしょう。',
];

//------------------------------------------------------------
// # 06 恋人 逆位置 浮気や衝突
cardsText.reverse['06-TheLovers'] = [

'「恋人」の逆位置は「浮気」や「衝突」を象徴し、関係における不誠実さや相手に対する疑念が高まることで、互いの絆が損なわれることを示唆しています。',

// ### あなたの気持ち  
'あなたは、相手に対する疑念や不信感を抱いており、相手の誠実さや忠誠心に対して不安を感じています。相手の行動や態度に対して何かしらの裏切りや不誠実さを感じ取っているため、心の中での葛藤が続いています。また、関係が不安定な状態にあることを強く意識しており、このままの状況が続くことに対する恐れがあなたの心に重くのしかかっているようです。あなたは今後の関係をどうするべきか、選択を迫られる立場にありますが、決断を下すことが難しい状況です。',

// ### 相手の気持ち  
'相手は、関係における責任感や真剣さに欠けており、誘惑や他の関係に気を取られている可能性があります。「恋人」の逆位置が示すように、相手は浮気や衝突の原因となる行動を無意識に取っているかもしれません。自分の感情や欲望に忠実であるがゆえに、相手は関係の維持に対して消極的であり、その結果、2人の間に誤解や衝突が生まれやすくなっています。また、相手は深いコミットメントに対して抵抗を感じており、関係に対する責任を回避しようとしている兆候が見られます。',

// ### 2人の現状  
'2人の関係は、現在大きな緊張状態にあります。「恋人」の逆位置は、愛と信頼の揺らぎ、さらには浮気や裏切りの可能性を示唆しており、関係が複雑化している状況です。お互いの価値観や欲求が衝突し、コミュニケーションの不足や誤解が関係を悪化させています。心の中で疑念が渦巻き、双方ともに関係の未来について真剣に考えなければならない時期に来ているのかもしれません。決定的な衝突や距離が生じる前に、対話を通じてお互いの本音を理解し合う必要があるでしょう。',

// ### 2人の近い未来  
'近い未来において、2人の関係はさらに試練に直面する可能性があります。「恋人」の逆位置は、誤解や疑念が深まり、衝突が激化することを示しています。相手の浮気や裏切りに対する不信感が高まり、信頼を回復するのが難しくなるかもしれません。また、双方が互いの立場や感情を尊重できない場合、最悪の結果として関係が破綻する可能性もあります。ただし、もし双方が真剣に対話を通じて問題を解決しようと努力すれば、新たな形での関係修復の道も残されているかもしれません。',
];

//------------------------------------------------------------
// # 07 戦車 逆位置 暴走や挑発
cardsText.reverse['07-TheChariot'] = [

'「戦車」の逆位置は「制御不能な状況」や「感情的な暴走」「挑発的な態度」を象徴し、無謀な行動や感情的な反応で人間関係に悪影響を及ぼすことを暗示しています。',

// ### あなたの気持ち  
'あなたは、今の関係において感情が高ぶり、理性よりも感情が先行してしまう状況に陥っています。「戦車」の逆位置が示すように、現状を打開したいという強い意志がある一方で、その焦りや苛立ちが相手との間で不和を生みやすくなっています。あなたは自分の考えや意見を強引に押し通そうとしているかもしれず、その結果、相手を無意識に挑発している可能性もあります。感情的な対立を避けたいと思っている一方で、冷静さを保つことができず、自分を見失いかけているかもしれません。',

// ### 相手の気持ち  
'相手は、あなたとの間で感じるプレッシャーや挑発的な態度に対して苛立ちを抱いているようです。相手もまた、理性を失いがちであり、感情的な反応をしてしまう場面が増えている可能性があります。「戦車」の逆位置は、相手が冷静さを失い、関係に対するコントロールを失いつつあることを示唆しています。相手も自分の考えを押し通したいという気持ちが強く、それが2人の間で対立や摩擦を生んでいるかもしれません。どちらも互いに譲らないことで、関係がより複雑化している状況です。',

// ### 2人の現状  
'現在の2人の関係は、激しい感情的な対立や摩擦が絶えない状況にあります。「戦車」の逆位置が象徴するように、双方ともにコントロールを失い、感情の暴走や挑発的な行動が増えています。互いに主導権を握りたいという強い意志が衝突し、協力的な態度が見られないため、状況はますます悪化しています。お互いに冷静さを欠いているため、コミュニケーションがうまく機能せず、誤解や衝突が続いている可能性が高いです。現在の関係は、非常に不安定で、いつ崩壊してもおかしくない状態です。',

// ### 2人の近い未来  
'このまま感情の高ぶりや挑発的な行動が続くと、近い未来において2人の関係はさらに深刻な危機に直面するでしょう。「戦車」の逆位置は、暴走する感情が状況を悪化させ、制御不能な事態に陥る可能性を示唆しています。もし2人が感情に流されるままに行動し続けるならば、関係は取り返しのつかない形で壊れてしまう危険性が高いです。お互いが冷静さを取り戻し、対話を通じて問題を解決しない限り、この関係は挑発や誤解によって崩れてしまうでしょう。',
];

//------------------------------------------------------------
// # 08 力 逆位置 臆病や強引
cardsText.reverse['08-Strength'] = [

'「力」の逆位置は「弱さ」や「臆病」「強引さを伴う行動」を象徴し、自分の感情に振り回されることで相手に対して不適切なアプローチをする可能性を示唆しています。',

// ### あなたの気持ち  
'あなたは現在、自己不信や不安を感じており、相手との関係において自信を失いつつある状況です。「力」の逆位置が示すように、心の中で恐怖や臆病さが強くなり、それがコミュニケーションや行動に表れている可能性があります。自分の感情を正直に表現することに躊躇しており、相手に対して弱い立場にあると感じているかもしれません。もしくは、内面の不安から無理に強がりを見せることで、かえって関係がぎこちなくなっている可能性もあります。この状況では、あなたは感情のコントロールが難しく、相手にどう接するべきか迷っているようです。',

// ### 相手の気持ち  
'相手もまた、あなたの態度や行動に対して混乱や不安を感じています。相手は、あなたの不安や強引さを敏感に感じ取り、その影響で自分自身も自信を失っているかもしれません。「力」の逆位置が示す通り、相手はあなたとの関係において無力感を抱いているか、あるいはその状況に対して過剰に反応し、強引に物事を進めようとする傾向が見られるかもしれません。お互いが弱さを見せることで関係が崩れやすくなっており、相手も内心ではこの状況をどう乗り越えるかを模索しています。',

// ### 2人の現状  
'2人の関係は、現在非常に不安定であり、互いの不安や弱さが表に出てしまっています。「力」の逆位置は、勇気や自信が欠如し、共に強引な行動に走ったり、逆に臆病さから積極的な行動を避けたりしていることを表しています。結果として、意思疎通がうまく取れず、感情のすれ違いが起こりやすい状況です。お互いに相手の期待に応えようとする一方で、自信のなさが行動にブレーキをかけ、結果として2人の関係に緊張感が漂っている状態です。この不安定さが続く限り、2人の関係はさらに悪化する可能性があります。',

// ### 2人の近い未来  
'近い未来において、2人がこの不安定な状況を乗り越えるには、まず互いに自分の弱さを認め、素直に向き合う必要があります。「力」の逆位置は、臆病さや不安を乗り越えなければ、関係が一層複雑になり、相手に対して強引に振る舞ってしまう危険性があることを示唆しています。もし2人が無理に状況を変えようとしたり、感情を抑え込んでしまうと、最終的には大きな衝突を招く恐れがあります。逆に、相手に対して理解と優しさを示し、時間をかけて問題に向き合えば、2人の絆はさらに強まる可能性があります。',
];

//------------------------------------------------------------
// # 09 隠者 逆位置 内向的や邪推
cardsText.reverse['09-TheHermit'] = [

'「隠者」の逆位置は「内向的な態度」や「物事を悲観的に捉える傾向」を象徴し、コミュニケーション不足が問題を悪化させる恐れを示唆しています。',

// ### あなたの気持ち  
'あなたは現在、相手との関係において心の距離を感じ、孤立感を抱いています。「隠者」の逆位置が表すように、自分の内面に深く潜り込みすぎており、相手との対話や意思疎通がうまくいかなくなっている可能性があります。また、相手の行動や言葉を過度に疑ったり、ネガティブに解釈してしまう傾向が強まっているようです。あなたは、自分が相手から理解されていないと感じている一方で、自ら心を開かずにいることが、関係をさらに難しくしていることに気づいていないかもしれません。',

// ### 相手の気持ち  
'相手は、あなたが内向的になり、感情を表に出さないことに不安を感じているようです。相手は、あなたが何かを隠しているのではないか、あるいは自分に対して不信感を抱いているのではないかと感じており、それが2人の関係における不安要素となっています。「隠者」の逆位置が示すように、相手は状況を誤解し、あなたの行動や態度に対して悲観的な見方をしてしまうことがあるかもしれません。相手はあなたとの距離を縮めたいと思っているものの、どう接していいか迷っている状況です。',

// ### 2人の現状  
'現在、2人の関係は停滞しており、互いの気持ちがうまく伝わらない状態です。「隠者」の逆位置は、内向的な姿勢が強まり、相手との交流を避ける傾向があることを示しています。お互いに心を閉ざし、疑念や誤解が積み重なることで、問題を解決するための対話が不足しています。2人は感情的なつながりを失いつつあり、それが関係の進展を妨げています。このままでは、冷え込んだ関係が長引き、修復がますます困難になる可能性があります。',

// ### 2人の近い未来  
'近い未来において、この閉塞感を打破するためには、互いに心を開き、誤解を解く努力が必要です。「隠者」の逆位置は、問題を解決するためには自己反省が重要であり、相手を疑うのではなく、信頼を再構築することが求められることを示しています。しかし、もし今のまま内向的な姿勢を続けるならば、2人の関係はますます孤立し、互いに誤解と不信感が深まる恐れがあります。対話の機会を大切にし、お互いに理解を示すことで、関係を再び温める可能性が見えてくるでしょう。',
];

//------------------------------------------------------------
// # 10 運命の輪 逆位置 誤算や災難
cardsText.reverse['10-WheelOfFortune'] = [

'「運命の輪」の逆位置は「誤算」や「予期しない災難」を象徴し、落胆や混乱により相手との信頼関係が揺らぐことを示唆しています。',

// ### あなたの気持ち  
'あなたは現在、相手との関係において不安感や疑念を抱いています。「運命の輪」の逆位置が示すように、思い描いていた理想の展開とは裏腹に、関係がうまくいっていないと感じています。誤算が重なり、相手との信頼が揺らいでいるため、心の中に不満や戸惑いが渦巻いています。このような状況では、自分の選択が誤りだったのではないかと自問自答し、自信を失っている可能性も高いです。自分の感情を整理できず、相手に対してどうアプローチするべきか迷っている状態にあります。',

// ### 相手の気持ち  
'相手は、現在の関係において予期せぬ困難や障害に直面していることを感じています。「運命の輪」の逆位置が示すように、相手は不安を抱きつつも、何が原因でこのような状況に陥ったのかを理解できずにいます。相手はあなたに対して感情的な距離を感じており、どのようにして信頼を取り戻すか悩んでいるかもしれません。このため、相手は自己防衛的になり、より引っ込み思案になっている可能性があります。こうした状況が続けば、相手はますます関係に対して消極的になる恐れがあります。',

// ### 2人の現状  
'現在、2人の関係は誤算や不運に見舞われ、停滞した状態にあります。「運命の輪」の逆位置は、予期せぬ出来事が影響し、互いに信頼感を築くことが難しくなっていることを示しています。2人はコミュニケーションが不足し、誤解や不安が積み重なっているため、関係が悪化する一方です。このままでは関係がさらに冷え込む可能性が高く、互いの心に距離ができてしまいます。誤算の連鎖を断ち切るために、何らかの対策を講じる必要があります。',

// ### 2人の近い未来  
'近い未来において、この状態を改善するためには、誤解を解くための率直な対話が不可欠です。「運命の輪」の逆位置は、今の問題を放置すると、さらなる誤算や災難が待ち受けていることを警告しています。このままでは関係が悪化する一方で、互いの心の距離が開くばかりです。しかし、もし勇気を持って話し合いを行えば、新たな理解や発見が生まれる可能性があります。信頼を再構築し、誤算を乗り越えるためには、まずは互いの気持ちを素直に伝えることが必要です。それによって、関係の回復の道が開けるでしょう。',
];

//------------------------------------------------------------
// # 11 正義 逆位置 不正や二股
cardsText.reverse['11-Justice'] = [

'「正義」の逆位置は「不正」や「二股」を象徴し、自分の利益を優先するあまり、相手を裏切るような行動が目立つ状況を示しています。',

// ### あなたの気持ち  
'あなたは現在、相手との関係において強い疑念や不安を抱えています。「正義」の逆位置が示すように、相手の行動に対して不信感が募り、これまでの信頼が揺らいでいる状態です。このため、あなたは心の中で葛藤を感じており、相手に対する愛情と同時に裏切られることへの恐れが入り混じっています。自分自身の感情や思考が混乱し、果たしてこの関係が正しいのか、または自分が利用されているのではないかという思いが強くなっています。こうした状況では、あなたは自分の選択が正しいのか再評価する必要があると感じています。',

// ### 相手の気持ち  
'相手は、現在の関係において不正や二股を意識している可能性があります。「正義」の逆位置が示すように、相手は自分の行動が他者に与える影響について深く考えず、目先の欲望に流されているかもしれません。このため、相手は本来の感情や相手に対する思いやりを見失いがちです。心の中では葛藤を抱えているものの、問題から目を背けることで自己を正当化している可能性があります。相手が自分の行動に気づき、真実に向き合うことができれば、関係の改善のきっかけになるでしょう。',

// ### 2人の現状  
'現在、2人の関係は不正や二股によって危機的な状況にあります。「正義」の逆位置が示すように、お互いに対する信頼が損なわれ、コミュニケーションが不足しています。疑念や誤解が生じており、無意識のうちに距離が生まれていることが感じられます。互いに自分の感情や状況に対して目を背けているため、問題を放置すると関係はさらに悪化する一方です。このままでは不信感が深まり、関係の回復が難しくなってしまう恐れがあります。',

// ### 2人の近い未来  
'近い未来において、この状況を改善するためには、互いに正直なコミュニケーションが必要です。「正義」の逆位置は、誤解を解くための行動を取らなければ、さらなる不正や裏切りが待ち受けていることを警告しています。問題を放置することで、より大きな亀裂が生じる可能性があります。しかし、もし勇気を持って話し合いを行えば、新たな理解や誠実さが生まれる可能性があります。相手との信頼を取り戻すためには、過去の過ちを反省し、誠意を持って相手に向き合うことが重要です。それによって、2人の関係は新たなスタートを切ることができるでしょう。',
];

//------------------------------------------------------------
// # 12 吊るされた男 逆位置 挫折や徒労
cardsText.reverse['12-TheHangedMan'] = [

'「吊るされた男」の逆位置は「挫折」や「徒労」を象徴し、努力が報われず、思ったように進展しない状況を意味します。',

// ### あなたの気持ち  
'あなたは、相手との関係において深い挫折感を抱えています。期待していたものが実現せず、努力が無駄に終わっているように感じており、心の中で葛藤を抱えています。自分の努力が報われないことに対する不満や焦りが募り、関係に対するモチベーションが徐々に失われている様子が伺えます。このため、あなたは自分の感情を整理し、次にどのように行動すべきかを真剣に考える必要があると感じています。何を求めているのか、自分自身と向き合うことが求められています。',

// ### 相手の気持ち  
'相手は現在、内面的な葛藤や不安を抱えています。「吊るされた男」の逆位置が示すように、相手もまた自分の努力が実を結ばないことに苛立ちを感じています。この状況に対する無力感から、積極的な行動を避けている傾向があります。自分の気持ちを表現することが難しくなっており、逃げ腰になっているかもしれません。相手の心の中では、自分が何を望んでいるのか明確でないため、関係の進展に対して消極的な姿勢が強まっています。このため、関係に対する熱意が失われている様子が見て取れます。',

// ### 2人の現状  
'現在、2人の関係は停滞しています。「吊るされた男」の逆位置が示すように、互いの努力が報われない状況が続いており、コミュニケーションが不足しています。疑念や不満が蓄積されており、どちらも自分の気持ちを相手に伝えることができずにいます。この停滞感は、互いに誤解を生み、距離を広げる要因となっています。お互いに何を求めているのか理解できず、行き詰まりを感じている状態です。このままでは関係がさらに冷却する恐れがあるため、早急に対話を持つことが求められます。',

// ### 2人の近い未来  
'近い未来においては、挫折感を乗り越えるための選択が重要になります。「吊るされた男」の逆位置は、過去の失敗や徒労から学び、次のステップに進む機会を示唆しています。問題を放置せず、互いに率直に気持ちを話し合うことが、関係の回復に繋がるでしょう。過去の出来事に対する理解や共感が生まれれば、再び関係を築くチャンスが訪れるはずです。焦らずに時間をかけて、信頼を再構築していく姿勢が求められます。このプロセスが、2人の未来に希望をもたらすことでしょう。',
];

//------------------------------------------------------------
// # 13 死神 逆位置 停滞や再開
cardsText.reverse['13-Death'] = [

'「死神」の逆位置は「停滞」や「再開」を象徴し、変化や新たな始まりが必要な時期に、何らかの理由で進展が妨げられていることを示しています。',

// ### あなたの気持ち  
'あなたは、関係の変化に対して戸惑いや不安を感じています。「死神」の逆位置が示すように、過去の出来事に未練が残り、次のステップに進むことが難しいと感じているようです。この停滞感は、未来に対する不安を引き起こし、相手との関係をどうするべきか悩んでいます。また、自分の気持ちが明確でないため、決断をするのが難しくなっています。過去の経験を踏まえて前に進みたいと思いながらも、何かしらの障害が立ちはだかり、心が揺れ動いている様子がうかがえます。',

// ### 相手の気持ち  
'相手は、現在の関係に対して曖昧な感情を抱いています。「死神」の逆位置が示す通り、相手もまた変化を恐れているようで、現状を維持しようとする気持ちが強いです。過去の出来事が心に引っかかり、関係の再開に対して消極的になっている可能性があります。また、相手は自分の気持ちを整理できず、何を求めているのか自問自答している状態です。このため、相手が積極的に関係を進展させることが難しく、どこか迷いが見える姿勢を示しています。',

// ### 2人の現状  
'現在、2人の関係は停滞しています。「死神」の逆位置が示すように、過去の出来事や感情が影響し、前に進むことができずにいます。互いに自分の気持ちを理解し合えていないため、関係の再構築に向けた具体的なアクションが欠けている状況です。コミュニケーションが不足しており、誤解や無理解が生じているかもしれません。このままでは、互いの距離が広がり続け、関係がますます複雑になる危険性があります。お互いにどのように進めていくかを考える必要があります。',

// ### 2人の近い未来  
'近い未来においては、停滞している状況からの再開が期待されます。「死神」の逆位置が示すように、過去の経験を踏まえて、関係の見直しが行われる可能性があります。お互いに冷静になり、自分の気持ちを整理することで、関係を再構築するためのチャンスが訪れるかもしれません。対話を通じて新たな理解が生まれれば、関係はより良い方向へ進むでしょう。このプロセスでは、過去の痛みを受け入れることが重要であり、その経験が未来の成長に繋がると考えられます。',
];

//------------------------------------------------------------
// # 14 節制 逆位置 不安定や怠惰
cardsText.reverse['14-Temperance'] = [

'「節制」の逆位置は「不安定」や「怠惰」を象徴し、バランスを欠いた状態や、自己管理の不足を暗示しています。',

// ### あなたの気持ち  
'あなたは、現在の関係に対して強い不安を抱いています。「節制」の逆位置が示すように、調和や安定が欠けているため、心の中で揺れ動く感情が大きくなっています。自分自身の感情をうまくコントロールできず、相手との関係に対する期待と不安が交錯している様子が伺えます。また、相手に対して何かしらの依存や期待を持っている一方で、自分の気持ちを正直に表現できていないことも、心の中での葛藤を生んでいます。自分自身の状況を見直し、行動を起こす必要があると感じつつも、怠惰や気の迷いがそれを妨げているようです。',

// ### 相手の気持ち  
'相手は、現在の関係に対して無関心や怠惰を感じているようです。「節制」の逆位置が示す通り、安定感がなく、感情の起伏が大きい状態です。このため、相手は自分の気持ちを整理することができず、何を求めているのかがはっきりしない状況にあるかもしれません。相手の中では内面的な葛藤が続いており、結果として行動に移すことができずにいます。この無関心や怠惰が関係の停滞を生み出し、あなたとのコミュニケーションにも影響を与えている可能性があります。互いに不安定さが続いているため、関係の再構築が難しい状況です。',

// ### 2人の現状  
'現在、2人の関係は不安定で、バランスを欠いています。「節制」の逆位置が示すように、どちらかが怠惰であったり、感情のコントロールができなかったりすることで、信頼や安定感が薄れている状態です。お互いの気持ちや思いを理解し合う努力が不足しており、これがさらなる誤解や対立を生む原因になっています。このままでは、互いに求め合うものが異なるため、関係はさらに混乱を極める危険性があります。相手の気持ちを軽視することなく、理解し合う努力をしなければ、関係の深化が望めないでしょう。',

// ### 2人の近い未来  
'近い未来においては、関係の不安定さが続く可能性があります。「節制」の逆位置が示す通り、怠惰や不安定な感情が、今後も2人の間に影響を及ぼすでしょう。しかし、どちらかが何らかの変化を起こさない限り、この状態が続くことになります。お互いの気持ちを理解し合うための対話が必要ですが、現時点ではその兆しが見えません。このまま無関心でいると、ますます関係が遠のく危険性があります。重要なのは、どちらかが自らの行動を見直し、関係の改善に向けた一歩を踏み出すことです。これができなければ、将来的には互いに大きな距離が生じてしまうかもしれません。',
];

//------------------------------------------------------------
// # 15 悪魔 逆位置 解放や回復
cardsText.reverse['15-TheDevil'] = [

'「悪魔」の逆位置は「解放」や「回復」を象徴し、過去の束縛や依存から解放される過程を暗示しています。',

// ### あなたの気持ち  
'あなたは、現在の関係に対して新たな希望や解放感を感じています。「悪魔」の逆位置は、過去の束縛やネガティブな感情から解放される兆しを示しています。以前の悩みや葛藤が薄れつつあり、自分自身を取り戻しつつある様子が見受けられます。今、あなたは相手との関係が新しい段階に進む可能性を感じており、前向きな気持ちを持っています。また、過去の出来事を受け入れ、それを成長の糧にすることで、より強固な絆を築くことができると信じています。相手とのコミュニケーションを改善する意欲も高まっており、関係の深化を望んでいます。',

// ### 相手の気持ち  
'相手も、過去の問題から解放されつつあるようです。「悪魔」の逆位置が示すように、相手は心の重荷を軽く感じ、自由な気持ちを取り戻しつつあります。これにより、相手は自分自身を再発見し、新たな視点から関係を見直す機会を得ています。以前は心の中で葛藤を抱えていたものの、それが徐々に和らいでいるため、相手は前向きな気持ちを持ち始めています。また、相手はあなたとの関係が持つ可能性を再認識し、より良い関係を築くための努力をしたいと考えています。この新たな気持ちが、2人の間にポジティブな影響を与えることを期待しています。',

// ### 2人の現状  
'現在、2人の関係は回復の兆しを見せています。「悪魔」の逆位置が表す通り、過去の束縛やトラウマから解放され、より自由な関係に向かいつつあります。お互いの気持ちや意見を理解し合うための対話が進んでおり、以前よりもオープンで正直なコミュニケーションが生まれています。この変化により、互いに成長する機会が増え、関係がより深く、意味のあるものになる可能性が高まっています。ただし、完全に過去を克服したわけではないため、注意深く進むことが重要です。両者が共に努力し続けることで、関係はより安定したものになっていくでしょう。',

// ### 2人の近い未来  
'近い未来においては、さらなる解放と回復のプロセスが続く見込みです。「悪魔」の逆位置が示すように、過去の痛みや不安が解消され、2人は新たな可能性に目を向けることができるでしょう。相互理解が深まることで、これまでの課題を乗り越え、より強い絆を築くことが期待されます。また、新しい活動や体験を共有することで、お互いの関係をより豊かにするチャンスが巡ってくるでしょう。ただし、過去の問題が完全に解決されたわけではないため、注意深く歩みを進めることが大切です。互いに支え合いながら、ポジティブな方向に向かうことが求められます。',
];

//------------------------------------------------------------
// # 16 塔 逆位置 誤解や揉め事
cardsText.reverse['16-TheTower'] = [

'「塔」の逆位置は「誤解」や「揉め事」を象徴し、予期しない出来事や変化が訪れることで、関係においてもトラブルや混乱が生じやすくなることを示唆しています。',

// ### あなたの気持ち  
'あなたは、現在の関係において多くの混乱や誤解を抱いています。「塔」の逆位置が示すように、以前のトラブルがまだ影を落としており、その影響で不安を感じています。特に、相手とのコミュニケーションにおいて言葉が正しく伝わらず、誤解が生じていることに苛立ちを覚えています。あなたは、自分の気持ちを相手に正確に理解してもらいたいと強く願っており、誤解を解消するための努力を惜しみません。ただ、現状があまりにも不安定で、どうアプローチすればよいか悩んでいる状態でもあります。このため、心の中で葛藤を抱えていることも否めません。',

// ### 相手の気持ち  
'相手は、現在の関係において混乱を感じているものの、その原因が何かを理解できずに戸惑っています。「塔」の逆位置は、相手が自分の感情を整理できていないことを示しており、誤解が生じていることに気づいていますが、具体的にどう対処すれば良いのか分からない状態です。相手はあなたとの関係を大切に思っているものの、もどかしさを感じ、少し距離を置いてしまっているかもしれません。相手もまた、心の中で不安を抱えているため、コミュニケーションが不足しがちになっている状況です。このことが、さらなる誤解を生む要因となっている可能性もあります。',

// ### 2人の現状  
'現在、2人の関係は非常に不安定で、誤解や揉め事が続いている状況です。「塔」の逆位置が表すように、かつての安定した関係が崩れ、互いに心の距離が広がっています。コミュニケーションが不足しているため、相手の気持ちや意図を正確に理解できず、互いに不満を抱えたままの状態です。特に、些細なことで意見が食い違い、余計な誤解を生んでしまっています。このまま放置すると関係がさらに悪化する恐れがあるため、何らかのアクションが必要です。両者が自らの気持ちを率直に表現し、誤解を解消する努力をしなければ、関係の改善は難しいと言えます。',

// ### 2人の近い未来  
'近い未来においては、誤解や揉め事が続く可能性があります。「塔」の逆位置が示すように、互いに心の中の疑念や不安を解消するためのアプローチが不足しているため、状況がさらに悪化するリスクがあります。ただし、この状態は決して永遠に続くわけではありません。両者が意識してコミュニケーションを改善することで、徐々に状況を好転させるチャンスもあります。例えば、共通の友人や信頼できる第三者を介して話をすることで、誤解を解消しやすくなるかもしれません。近い未来には、真摯な対話を通じて関係が修復されることが期待されますが、そのためには双方の努力が不可欠です。',
];

//------------------------------------------------------------
// # 17 星 逆位置 失望や諦念
cardsText.reverse['17-TheStar'] = [

'「星」の逆位置は「失望」や「諦念」を象徴し、希望や目標に対する期待が裏切られ、失望感が強まる状態を意味します。',

// ### あなたの気持ち  
'あなたは、現在の関係に対して深い失望を感じています。「星」の逆位置が示すように、かつて持っていた希望が薄れ、相手との未来に対する期待が持てなくなっているのです。特に、相手の言動が思っていたものと異なり、信じていた夢が崩れつつあることに苦しんでいます。心の中で「これ以上期待しても無駄ではないか」と感じる瞬間が増え、自分の感情をどう扱えばよいのか分からず、戸惑いを覚えています。この状況から抜け出したいと強く願いつつも、どう行動すればよいのか悩んでいるのです。',

// ### 相手の気持ち  
'相手は、あなたとの関係において複雑な感情を抱えています。「星」の逆位置が示す通り、相手もまた失望感を感じており、状況が思うように進展しないことに心を痛めています。以前のような明るい未来を描けず、希望を持てなくなっている自分に気づいているものの、その原因を具体的に理解できていない状態です。相手は、あなたが抱える不安や疑念を察知しながらも、自分自身の気持ちを整理できていないため、適切な行動が取れないでいます。このまま関係が続いてしまうことに対する恐れも抱えています。',

// ### 2人の現状  
'現在、2人の関係は非常に緊張した状況にあります。「星」の逆位置が表すように、両者が互いに失望を感じており、コミュニケーションが不足しています。過去の期待が裏切られた結果、互いに心の距離が広がり、どちらも進展を望みながらも、どう動けばよいのか迷っています。何らかの解決策を見出したいと思いながらも、具体的なアクションが取れず、状況は停滞しています。このまま放置すれば、さらなる誤解や距離感が生じる恐れがあります。互いの思いを正直に話し合う必要がありますが、そのための勇気が足りていないのです。',

// ### 2人の近い未来  
'近い未来において、状況はあまり好転しない可能性があります。「星」の逆位置が示す通り、失望感が続き、互いに自分の気持ちをうまく表現できずにいるため、さらなる距離が生まれてしまうかもしれません。この状態が続けば、2人の関係はさらに冷え込み、コミュニケーションの機会が減ってしまうリスクがあります。ただし、双方が心の中の葛藤を解消する努力を始めることで、少しずつでも状況を改善するチャンスもあります。互いに理解し合おうとする姿勢を持つことで、少しずつ信頼を取り戻し、関係を再構築することができるでしょう。希望を持ち続けることが、未来の明るい道につながるかもしれません。',
];

//------------------------------------------------------------
// # 18 月 逆位置 変化や失敗
cardsText.reverse['18-TheMoon'] = [

'「月」の逆位置は「変化」や「失敗」を象徴し、混乱や不安が先鋭化することで、重要な変化が避けられない状況を示しています。',

// ### あなたの気持ち  
'あなたは、現在の関係に対して不安を抱えています。「月」の逆位置が示すように、相手は変化の波にさらされていると感じており、未来が見えないことがストレスとなっています。信頼していた相手との関係が不安定になっていることに心を痛め、自己疑念が芽生えているのです。以前のような安定感を取り戻したいと強く思っている一方で、どのように行動すれば良いのかが分からず、迷っている状態です。心の中で、失敗を恐れる気持ちが強くなり、なかなか前向きになれずにいます。',

// ### 相手の気持ち  
'相手もまた、あなたとの関係において混乱を感じています。「月」の逆位置は、相手にとっても不安定さを象徴しています。相手は、自分の気持ちや行動があなたにどう影響するのかを考えすぎてしまい、結果的に行動に移せずにいます。自分自身の内面に向き合う時間が長くなり、その結果、あなたとのコミュニケーションが減少してしまっているのです。相手は、変化を恐れるあまり、関係の進展を妨げていることに気づいていますが、どうすれば良いか決断できないでいます。',

// ### 2人の現状  
'現在、2人の関係は不安定な状況にあります。「月」の逆位置が表すように、互いに不安や疑念を抱えており、心の距離が広がっています。問題を放置した結果、誤解やすれ違いが生じ、両者ともに本音を言えないまま時間が過ぎてしまっています。会話が減り、以前のような親密さは失われつつあり、互いの信頼関係も揺らいでいます。このままでは、関係がさらに悪化する危険性があるため、何らかのアクションが必要です。しかし、どちらも動けずにいるのが現状です。',

// ### 2人の近い未来  
'近い未来では、状況がより一層明確になる可能性があります。「月」の逆位置が示すように、変化が避けられない中で、互いの思いを正直に話し合うことが求められています。もしこの機会を逃さずにコミュニケーションを図れば、関係は改善に向かうかもしれません。ただし、互いの不安をしっかりと認識し、理解し合う努力が必要です。コミュニケーションの中で誤解を解消し、信頼を再構築するチャンスがあります。過去の失敗を学びとし、前向きな変化を受け入れる姿勢が鍵となるでしょう。',
];

//------------------------------------------------------------
// # 19 太陽 逆位置 衰退や落胆
cardsText.reverse['19-TheSun'] = [

'「太陽」の逆位置は「衰退」や「落胆」を象徴し、明るいエネルギーが欠如し、関係においても活力を失ってしまう状態を意味します。',

// ### あなたの気持ち  
'あなたは、現在の関係に対して深い失望感を抱えています。「太陽」の逆位置が示すように、以前は希望に満ちていた関係が、今は暗い影を落としていると感じています。楽しい思い出や未来への期待が薄れ、日常の中に無気力さが漂っています。相手は、自分の努力が報われていないと感じ、コミュニケーションの不足や誤解が原因で、心の距離が広がっていることに胸を痛めています。孤独感や疎外感が募る中、どうにかして明るい未来を取り戻したいと願っているものの、方法が見えない状態です。',

// ### 相手の気持ち  
'相手もまた、2人の関係に対して重い気持ちを抱えています。「太陽」の逆位置が示すように、相手は過去の楽しい時間が嘘のように感じられ、今の状況に対する無力感に苛まれています。お互いの距離が広がっていることに心を痛めながらも、どのように対処すれば良いのか分からず、悩んでいます。相手は自分の感情をうまく表現できず、沈んだ気持ちが内面に閉じ込められてしまっています。問題を解決しようとする意欲はあるものの、思い悩むあまり行動に移せずにいる状態です。',

// ### 2人の現状  
'現在、2人の関係は不安定で、互いにネガティブな感情を抱えています。「太陽」の逆位置が表すように、明るさや喜びが失われ、コミュニケーションも減少しています。相手を思いやる気持ちが薄れ、些細なことでの衝突や誤解が増えているのが現状です。このままでは関係が悪化する一方で、互いに解決策を見出すことができないでいます。互いの感情を無視し続ける限り、暗いトンネルから抜け出せないままの状態が続く恐れがあります。',

// ### 2人の近い未来  
'近い未来においては、関係の改善が期待できるものの、まずは自分たちの感情に向き合うことが不可欠です。「太陽」の逆位置が示す暗い影を払拭するためには、互いに本音を語り合う時間が必要です。過去の誤解やすれ違いを洗い出し、理解し合うことで、新たなスタートを切る可能性があります。しかし、心の中の落胆や失望を無視しては進展は見込めません。誠実なコミュニケーションが求められる時期であり、その努力が未来を照らす光となるでしょう。',
];

//------------------------------------------------------------
// # 20 審判 逆位置 手詰まりや未練
cardsText.reverse['20-Judgement'] = [

'「審判」の逆位置は「手詰まり」や「未練」を象徴し、過去にこだわりが強く、なかなか新たな一歩を踏み出せない状態を示します。',

// ### あなたの気持ち  
'あなたは現在、関係に対して強い未練を抱いています。「審判」の逆位置が示すように、過去の出来事や感情から抜け出せず、先へ進むことができないでいます。相手は相手との関係が終わったことに対する悲しみや後悔を強く感じ、復活の希望を捨てられずにいます。相手の心の中には、過去の幸福な瞬間が鮮明に残っており、その思い出に囚われ続けている様子が見受けられます。このため、前向きな決断ができずにいることが、内面的な葛藤を生んでいます。',

// ### 相手の気持ち  
'相手もまた、過去の出来事に対する思いを断ち切れずにいます。「審判」の逆位置が示すように、相手は手詰まりの状態にあり、進展が望めないと感じています。相手の心には後悔や迷いが渦巻き、別れを選んだ理由を問い直す瞬間が増えています。ただ、相手はそれを口に出せずにいるため、無言のままの状態が続いています。相手の中では、自分の気持ちと相手への思いが交錯し、次にどのように行動すれば良いのかが分からずにいます。この曖昧さが、さらに関係を複雑にしているのです。',

// ### 2人の現状  
'現在、2人の関係は停滞しています。「審判」の逆位置が示すように、お互いが過去を引きずっているために、新たなスタートを切ることができていません。コミュニケーションが不足し、互いの気持ちを理解し合うことが難しくなっています。未練や後悔が両者の心に存在する一方で、それを解決するためのアクションを起こす勇気が持てず、現状維持のまま進展がありません。負の感情が充満し、どちらも前に進めずにいる状態が続いています。',

// ### 2人の近い未来  
'近い未来においては、状況を打破するための選択が求められます。「審判」の逆位置が示すように、未練や後悔から解放されるためには、何らかの決断が必要です。もしかすると、再び向き合う機会が訪れるかもしれませんが、それは双方が自分の感情に向き合い、過去を整理することで実現します。何かのきっかけで互いに心の内を話す機会があれば、新たな道が開ける可能性があります。ただし、解決策を見出すためには、まずは自己を見つめ直すことが重要です。行動を起こさなければ、未来もまた現状維持のままとなってしまうでしょう。',
];

//------------------------------------------------------------
// # 21 世界 逆位置 不完全や崩壊
cardsText.reverse['21-TheWorld'] = [

'「世界」の逆位置は「不完全」や「崩壊」を象徴し、達成感や完成を感じられない状況を示しています。',

// ### あなたの気持ち  
'あなたは現在、関係の不完全さに対して強い不安を抱えています。「世界」の逆位置が示すように、相手は自分と相手との関係が最終的にうまくいかないのではないかという恐れを感じています。完結や達成を求めているものの、状況が思い通りに進まないことで、心に重くのしかかる感情が生まれています。このため、相手の心は不安定であり、愛情と不安の間で揺れ動いています。何かを成し遂げたいという願望は強いものの、現実がそれを妨げていることに苛立ちを覚えているのです。',

// ### 相手の気持ち  
'相手もまた、関係の崩壊の不安を感じている状況にあります。「世界」の逆位置は、相手にとっても心の安定を欠いていることを示しています。相手は関係が完成されていないことに対する失望感を抱いており、そのため自信を失っている可能性があります。相手の中には、これまでの努力が無駄になるのではないかという懸念があり、もどかしさを感じています。相手は、現状を打破するための手段を見出すことができず、非常に葛藤している様子が見て取れます。このため、相手の心もまた不安定な状態にあります。',

// ### 2人の現状  
'2人の関係は現在、不完全な状態にあります。「世界」の逆位置が示すように、互いのコミュニケーションが不足しており、誤解が生じやすい状況です。お互いが持っている期待や夢が現実には叶えられず、無力感を抱いている状態が続いています。このため、両者の心にはかすかな希望と強い不安が同居しており、関係が崩壊の危機にあることを意識せざるを得ない状況です。問題を放置することで、ますます関係が悪化する恐れがあるため、何らかの解決策を見出すことが求められています。',

// ### 2人の近い未来  
'近い未来において、2人の関係はより厳しい局面を迎える可能性があります。「世界」の逆位置が示すように、現状が変わらないまま進むと、さらなる不安定さが増してしまいます。お互いに向き合わないままでは、関係が崩壊してしまう恐れがあります。具体的な行動やコミュニケーションを避け続けることで、無理解や誤解が深まってしまうでしょう。しかし、今こそお互いの気持ちを正直に話し合うタイミングかもしれません。解決策を模索することで、未来に向けた新たな道が開かれる可能性もあるため、両者にとって勇気ある一歩が必要です。',
];

//------------------------------------------------------------
// Test: exist data
const test = function() {
    const table = cards.map((card, i) => {
        const name = cardsName[card];
        const upright = cardsText.upright[card].length;
        const reverse = cardsText.reverse[card].length;
        return {card, name, upright, reverse};
    });
    console.table(table);
};
//test();
